const addLoadLocationData = [
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1104",
        "town": "Seyhan",
        "location": "Seyhan/Adana (Merkez)",
        "lat": "37.0326567700636",
        "lng": "35.2531484850264",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1757",
        "town": "Aladağ",
        "location": "Aladağ/Adana",
        "lat": "37.55071063405780",
        "lng": "35.39278963458750",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1219",
        "town": "Ceyhan",
        "location": "Ceyhan/Adana",
        "lat": "37.05205318490160",
        "lng": "35.81012170890090",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "2033",
        "town": "Çukurova",
        "location": "Çukurova/Adana",
        "lat": "37.04290129502140",
        "lng": "35.25563518929210",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1329",
        "town": "Feke",
        "location": "Feke/Adana",
        "lat": "37.81161922264841",
        "lng": "35.90833836178090",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1806",
        "town": "İmamoğlu",
        "location": "İmamoğlu/Adana",
        "lat": "37.24990197339970",
        "lng": "35.67036787471830",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1437",
        "town": "Karaisalı",
        "location": "Karaisalı/Adana",
        "lat": "37.24990590462810",
        "lng": "35.06936070727761",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1443",
        "town": "Karataş",
        "location": "Karataş/Adana",
        "lat": "36.56833407382021",
        "lng": "35.38337585207510",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1486",
        "town": "Kozan",
        "location": "Kozan/Adana",
        "lat": "37.44189982025970",
        "lng": "35.79567004689430",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1580",
        "town": "Pozantı",
        "location": "Pozantı/Adana",
        "lat": "37.42688830115040",
        "lng": "34.87517637171250",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1588",
        "town": "Saimbeyli",
        "location": "Saimbeyli/Adana",
        "lat": "37.97937044073350",
        "lng": "36.08717559963010",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "2032",
        "town": "Sarıçam",
        "location": "Sarıçam/Adana",
        "lat": "37.14815399274970",
        "lng": "35.50946020576081",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1687",
        "town": "Tufanbeyli",
        "location": "Tufanbeyli/Adana",
        "lat": "38.25192917674270",
        "lng": "36.21793967164110",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1734",
        "town": "Yumurtalık",
        "location": "Yumurtalık/Adana",
        "lat": "36.78190853361510",
        "lng": "35.78899990881490",
        "region": "Akdeniz"
    },
    {
        "cityId": "1",
        "city": "Adana",
        "townId": "1748",
        "town": "Yüreğir",
        "location": "Yüreğir/Adana",
        "lat": "36.98998593572380",
        "lng": "35.33827052521310",
        "region": "Akdeniz"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1105",
        "town": "Merkez",
        "location": "Merkez/Adıyaman",
        "lat": "37.7630625360774",
        "lng": "38.2727201022289",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1182",
        "town": "Besni",
        "location": "Besni/Adıyaman",
        "lat": "37.68644910938481",
        "lng": "37.87234331961900",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1246",
        "town": "Çelikhan",
        "location": "Çelikhan/Adıyaman",
        "lat": "38.02672494484690",
        "lng": "38.21997898688630",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1347",
        "town": "Gerger",
        "location": "Gerger/Adıyaman",
        "lat": "38.02033490774180",
        "lng": "39.02745715053630",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1354",
        "town": "Gölbaşı",
        "location": "Gölbaşı/Adıyaman",
        "lat": "37.78473961412300",
        "lng": "37.64377743009410",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1425",
        "town": "Kahta",
        "location": "Kahta/Adıyaman",
        "lat": "37.78848042682400",
        "lng": "38.60262604570040",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1592",
        "town": "Samsat",
        "location": "Samsat/Adıyaman",
        "lat": "37.58737923562160",
        "lng": "38.47711040247230",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1985",
        "town": "Sincik",
        "location": "Sincik/Adıyaman",
        "lat": "38.02084157971280",
        "lng": "38.61870008723640",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "2",
        "city": "Adıyaman",
        "townId": "1989",
        "town": "Tut",
        "location": "Tut/Adıyaman",
        "lat": "37.79159525292470",
        "lng": "37.91940299929020",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1108",
        "town": "Merkez",
        "location": "Merkez/Afyonkarahisar",
        "lat": "38.7682264428084",
        "lng": "30.5813302659877",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1771",
        "town": "Başmakçı",
        "location": "Başmakçı/Afyonkarahisar",
        "lat": "37.89880059521130",
        "lng": "30.00941333513110",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1773",
        "town": "Bayat",
        "location": "Bayat/Afyonkarahisar",
        "lat": "38.97405543792690",
        "lng": "30.92511037080490",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1200",
        "town": "Bolvadin",
        "location": "Bolvadin/Afyonkarahisar",
        "lat": "38.70615979584080",
        "lng": "31.03444316099950",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1239",
        "town": "Çay",
        "location": "Çay/Afyonkarahisar",
        "lat": "38.59713351318270",
        "lng": "31.02877280031620",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1906",
        "town": "Çobanlar",
        "location": "Çobanlar/Afyonkarahisar",
        "lat": "38.69809594234821",
        "lng": "30.76941168052150",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1267",
        "town": "Dazkırı",
        "location": "Dazkırı/Afyonkarahisar",
        "lat": "37.92502276252850",
        "lng": "29.87109118186840",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1281",
        "town": "Dinar",
        "location": "Dinar/Afyonkarahisar",
        "lat": "38.05824191212250",
        "lng": "30.15898934899360",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1306",
        "town": "Emirdağ",
        "location": "Emirdağ/Afyonkarahisar",
        "lat": "39.03425133422540",
        "lng": "31.16254751288380",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1923",
        "town": "Evciler",
        "location": "Evciler/Afyonkarahisar",
        "lat": "38.03173835146201",
        "lng": "29.90942906345690",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1944",
        "town": "Hocalar",
        "location": "Hocalar/Afyonkarahisar",
        "lat": "38.57614206511820",
        "lng": "29.96354284416940",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1404",
        "town": "İhsaniye",
        "location": "İhsaniye/Afyonkarahisar",
        "lat": "39.02048465268291",
        "lng": "30.40837606016060",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1809",
        "town": "İscehisar",
        "location": "İscehisar/Afyonkarahisar",
        "lat": "38.84427807862700",
        "lng": "30.74244768013570",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1961",
        "town": "Kızılören",
        "location": "Kızılören/Afyonkarahisar",
        "lat": "38.25961740089540",
        "lng": "30.15823508254960",
        "region": "Ege"
    },
    
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1594",
        "town": "Sandıklı",
        "location": "Sandıklı/Afyonkarahisar",
        "lat": "38.46170388949530",
        "lng": "30.26031671668730",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1626",
        "town": "Sinanpaşa",
        "location": "Sinanpaşa/Afyonkarahisar",
        "lat": "38.75109131279030",
        "lng": "30.24733586021660",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1639",
        "town": "Sultandağı",
        "location": "Sultandağı/Afyonkarahisar",
        "lat": "38.53637308767710",
        "lng": "31.24123747389900",
        "region": "Ege"
    },
    {
        "cityId": "3",
        "city": "Afyonkarahisar",
        "townId": "1664",
        "town": "Şuhut",
        "location": "Şuhut/Afyonkarahisar",
        "lat": "38.54500983803900",
        "lng": "30.55930843267400",
        "region": "Ege"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1111",
        "town": "Merkez",
        "location": "Merkez/Ağrı",
        "lat": "39,7081525291599",
        "lng": "43,0487815512519",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1283",
        "town": "Diyadin",
        "location": "Diyadin/Ağrı",
        "lat": "39.56165097380580",
        "lng": "43.65209950500610",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1287",
        "town": "Doğubayazıt",
        "location": "Doğubayazıt/Ağrı",
        "lat": "39.54293004098681",
        "lng": "44.04324090297731",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1301",
        "town": "Eleşkirt",
        "location": "Eleşkirt/Ağrı",
        "lat": "39.79497583473100",
        "lng": "42.67780920456180",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1379",
        "town": "Hamur",
        "location": "Hamur/Ağrı",
        "lat": "39.61221253919880",
        "lng": "42.99310444718270",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1568",
        "town": "Patnos",
        "location": "Patnos/Ağrı",
        "lat": "39.23749427958210",
        "lng": "42.85319315647601",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1667",
        "town": "Taşlıçay",
        "location": "Taşlıçay/Ağrı",
        "lat": "39.64336160277491",
        "lng": "43.37128415947020",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "4",
        "city": "Ağrı",
        "townId": "1691",
        "town": "Tutak",
        "location": "Tutak/Ağrı",
        "lat": "39.53616473430360",
        "lng": "42.77378220748890",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1120",
        "town": "Merkez",
        "location": "Merkez/Aksaray",
        "lat": "38,3642363227308",
        "lng": "34,0079439956918",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1860",
        "town": "Ağaçören",
        "location": "Ağaçören/Aksaray",
        "lat": "38.87348946072600",
        "lng": "33.91393000291060",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1921",
        "town": "Eskil",
        "location": "Eskil/Aksaray",
        "lat": "38.40176534513450",
        "lng": "33.41277734478840",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1932",
        "town": "Gülağaç",
        "location": "Gülağaç/Aksaray",
        "lat": "38.39203636119080",
        "lng": "34.34648811414720",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1861",
        "town": "Güzelyurt",
        "location": "Güzelyurt/Aksaray",
        "lat": "38.27758446312830",
        "lng": "34.37258676774610",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1557",
        "town": "Ortaköy",
        "location": "Ortaköy/Aksaray",
        "lat": "38.73669851855970",
        "lng": "34.03882341704030",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "1866",
        "town": "Sarıyahşi",
        "location": "Sarıyahşi/Aksaray",
        "lat": "38.98591123681930",
        "lng": "33.84439850542460",
        "region": "İç Anadolu"
    },
    {
        "cityId": "68",
        "city": "Aksaray",
        "townId": "2106",
        "town": "Sultanhanı",
        "location": "Sultanhanı/Aksaray",
        "lat": "38.25068401538160",
        "lng": "33.54516531713390",
        "region": "İç Anadolu"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1134",
        "town": "Merkez",
        "location": "Merkez/Amasya",
        "lat": "40,6332502648702",
        "lng": "35,8127489041194",
        "region": "Karadeniz"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1363",
        "town": "Göynücek",
        "location": "Göynücek/Amasya",
        "lat": "40.40040796523850",
        "lng": "35.53755303657300",
        "region": "Karadeniz"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1368",
        "town": "Gümüşhacıköy",
        "location": "Gümüşhacıköy/Amasya",
        "lat": "40.88161463976430",
        "lng": "35.21982659046740",
        "region": "Karadeniz"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1938",
        "town": "Hamamözü",
        "location": "Hamamözü/Amasya",
        "lat": "40.78613777088640",
        "lng": "35.03248011574570",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1524",
        "town": "Merzifon",
        "location": "Merzifon/Amasya",
        "lat": "40.85766995582180",
        "lng": "35.46268882522820",
        "region": "Karadeniz"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1641",
        "town": "Suluova",
        "location": "Suluova/Amasya",
        "lat": "40.82421528664390",
        "lng": "35.63447768183550",
        "region": "Karadeniz"
    },
    {
        "cityId": "5",
        "city": "Amasya",
        "townId": "1668",
        "town": "Taşova",
        "location": "Taşova/Amasya",
        "lat": "40.75553458979330",
        "lng": "36.32358790135020",
        "region": "Karadeniz"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1922",
        "town": "Etimesgut",
        "location": "Etimesgut/Ankara (Merkez)",
        "lat": "39.9253899034945",
        "lng": "32.7077001563963",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1872",
        "town": "Akyurt",
        "location": "Akyurt/Ankara",
        "lat": "40.13487861224170",
        "lng": "33.08467531198520",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1130",
        "town": "Altındağ",
        "location": "Altındağ/Ankara",
        "lat": "39.95767495928750",
        "lng": "32.88972519069900",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1157",
        "town": "Ayaş",
        "location": "Ayaş/Ankara",
        "lat": "40.01899030206730",
        "lng": "32.32827786608761",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1167",
        "town": "Bala",
        "location": "Bala/Ankara",
        "lat": "39.56422921967151",
        "lng": "33.10572930582620",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1187",
        "town": "Beypazarı",
        "location": "Beypazarı/Ankara",
        "lat": "40.17220451408120",
        "lng": "31.93300487969400",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1227",
        "town": "Çamlıdere",
        "location": "Çamlıdere/Ankara",
        "lat": "40.48665430574460",
        "lng": "32.46474200381580",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1231",
        "town": "Çankaya",
        "location": "Çankaya/Ankara",
        "lat": "39.91349145972830",
        "lng": "32.85390097866170",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1260",
        "town": "Çubuk",
        "location": "Çubuk/Ankara",
        "lat": "40.20632931660250",
        "lng": "33.03253922703910",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1302",
        "town": "Elmadağ",
        "location": "Elmadağ/Ankara",
        "lat": "39.92034735546890",
        "lng": "33.22151028028870",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1924",
        "town": "Evren",
        "location": "Evren/Ankara",
        "lat": "39.01381571191331",
        "lng": "33.79828153361360",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1744",
        "town": "Gölbaşı",
        "location": "Gölbaşı/Ankara",
        "lat": "39.78754788525760",
        "lng": "32.80540236818120",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1365",
        "town": "Güdül",
        "location": "Güdül/Ankara",
        "lat": "40.21541870357290",
        "lng": "32.25293817130941",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1387",
        "town": "Haymana",
        "location": "Haymana/Ankara",
        "lat": "39.43042923742910",
        "lng": "32.52126040198630",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1815",
        "town": "Kahramankazan",
        "location": "Kahramankazan/Ankara",
        "lat": "40.19422890845950",
        "lng": "32.69113147156130",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1427",
        "town": "Kalecik",
        "location": "Kalecik/Ankara",
        "lat": "40.11758539576790",
        "lng": "33.41265857297040",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1745",
        "town": "Keçiören",
        "location": "Keçiören/Ankara",
        "lat": "39.98441959093890",
        "lng": "32.86342573135120",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1473",
        "town": "Kızılcahamam",
        "location": "Kızılcahamam/Ankara",
        "lat": "40.45913481464320",
        "lng": "32.65315936112821",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1746",
        "town": "Mamak",
        "location": "Mamak/Ankara",
        "lat": "39.92681183250660",
        "lng": "32.92060922388240",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1539",
        "town": "Nallıhan",
        "location": "Nallıhan/Ankara",
        "lat": "40.18878628112760",
        "lng": "31.35037079391230",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1578",
        "town": "Polatlı",
        "location": "Polatlı/Ankara",
        "lat": "39.57622222959760",
        "lng": "32.14498861565280",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "2034",
        "town": "Pursaklar",
        "location": "Pursaklar/Ankara",
        "lat": "40.03186838727460",
        "lng": "32.90197965437060",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1747",
        "town": "Sincan",
        "location": "Sincan/Ankara",
        "lat": "39.97795003032140",
        "lng": "32.58152629142870",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1658",
        "town": "Şereflikoçhisar",
        "location": "Şereflikoçhisar/Ankara",
        "lat": "38.93792062399200",
        "lng": "33.53912316048520",
        "region": "İç Anadolu"
    },
    {
        "cityId": "6",
        "city": "Ankara",
        "townId": "1723",
        "town": "Yenimahalle",
        "location": "Yenimahalle/Ankara",
        "lat": "39.97001389727380",
        "lng": "32.71687079415450",
        "region": "İç Anadolu"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "2036",
        "town": "Döşemealtı",
        "location": "Döşemealtı/Antalya (Merkez)",
        "lat": "37.0229543610812",
        "lng": "30.6012861216825",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1121",
        "town": "Akseki",
        "location": "Akseki/Antalya",
        "lat": "37.03892162524420",
        "lng": "31.78458866884640",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "2035",
        "town": "Aksu",
        "location": "Aksu/Antalya",
        "lat": "36.94541723616450",
        "lng": "30.83103391157300",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1126",
        "town": "Alanya",
        "location": "Alanya/Antalya",
        "lat": "36.55115587286070",
        "lng": "32.01551151370940",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1811",
        "town": "Demre",
        "location": "Demre/Antalya",
        "lat": "36.23883596792600",
        "lng": "29.98870298127990",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1303",
        "town": "Elmalı",
        "location": "Elmalı/Antalya",
        "lat": "36.73063883076980",
        "lng": "29.93216732301410",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1333",
        "town": "Finike",
        "location": "Finike/Antalya",
        "lat": "36.30692246760411",
        "lng": "30.15891022433970",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1337",
        "town": "Gazipaşa",
        "location": "Gazipaşa/Antalya",
        "lat": "36.27283898716990",
        "lng": "32.31011285980010",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1370",
        "town": "Gündoğmuş",
        "location": "Gündoğmuş/Antalya",
        "lat": "36.81639706020640",
        "lng": "31.99881090835940",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1946",
        "town": "İbradı",
        "location": "İbradı/Antalya",
        "lat": "37.09199261150260",
        "lng": "31.59654959469710",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1451",
        "town": "Kaş",
        "location": "Kaş/Antalya",
        "lat": "36.20696168862080",
        "lng": "29.63216513853890",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1959",
        "town": "Kemer",
        "location": "Kemer/Antalya",
        "lat": "36.61929727682020",
        "lng": "30.55299869759780",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "2037",
        "town": "Kepez",
        "location": "Kepez/Antalya",
        "lat": "36.92210163824280",
        "lng": "30.66901121979460",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "2038",
        "town": "Konyaaltı",
        "location": "Konyaaltı/Antalya",
        "lat": "36.89691639583431",
        "lng": "30.71332233726840",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1483",
        "town": "Korkuteli",
        "location": "Korkuteli/Antalya",
        "lat": "37.05989434076620",
        "lng": "30.22614960013970",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1492",
        "town": "Kumluca",
        "location": "Kumluca/Antalya",
        "lat": "36.36359245122560",
        "lng": "30.30093067278480",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1512",
        "town": "Manavgat",
        "location": "Manavgat/Antalya",
        "lat": "36.77815321261140",
        "lng": "31.43589367459710",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "2039",
        "town": "Muratpaşa",
        "location": "Muratpaşa/Antalya",
        "lat": "36.89691913624430",
        "lng": "30.71331314295130",
        "region": "Akdeniz"
    },
    {
        "cityId": "7",
        "city": "Antalya",
        "townId": "1616",
        "town": "Serik",
        "location": "Serik/Antalya",
        "lat": "36.91258701957711",
        "lng": "31.10587325513120",
        "region": "Akdeniz"
    },
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "1144",
        "town": "Merkez",
        "location": "Merkez/Ardahan",
        "lat": "41,0996768228486",
        "lng": "42,710023494941",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "1252",
        "town": "Çıldır",
        "location": "Çıldır/Ardahan",
        "lat": "41.12676077912390",
        "lng": "43.13396595368590",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "2008",
        "town": "Damal",
        "location": "Damal/Ardahan",
        "lat": "41.33978590201560",
        "lng": "42.83860997785300",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "1356",
        "town": "Göle",
        "location": "Göle/Ardahan",
        "lat": "40.79349392449130",
        "lng": "42.61011346963960",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "1380",
        "town": "Hanak",
        "location": "Hanak/Ardahan",
        "lat": "41.22774070412970",
        "lng": "42.84992724164070",
        "region": "Doğu Anadolu"
    },
   
    {
        "cityId": "75",
        "city": "Ardahan",
        "townId": "1579",
        "town": "Posof",
        "location": "Posof/Ardahan",
        "lat": "41.50607276081540",
        "lng": "42.72817629672390",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1152",
        "town": "Merkez",
        "location": "Merkez/Artvin",
        "lat": "41,1819300503459",
        "lng": "41,8366223368429",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1145",
        "town": "Ardanuç",
        "location": "Ardanuç/Artvin",
        "lat": "41.11778912046080",
        "lng": "42.06672922950660",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1147",
        "town": "Arhavi",
        "location": "Arhavi/Artvin",
        "lat": "41.35446824485760",
        "lng": "41.30818360165210",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1202",
        "town": "Borçka",
        "location": "Borçka/Artvin",
        "lat": "41.35852386329040",
        "lng": "41.67658463147910",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1395",
        "town": "Hopa",
        "location": "Hopa/Artvin",
        "lat": "41.39164785457450",
        "lng": "41.41617585673920",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "2105",
        "town": "Kemalpaşa",
        "location": "Kemalpaşa/Artvin",
        "lat": "41.48230968855411",
        "lng": "41.52320253948200",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1828",
        "town": "Murgul",
        "location": "Murgul/Artvin",
        "lat": "41.29170053359170",
        "lng": "41.57877195106410",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1653",
        "town": "Şavşat",
        "location": "Şavşat/Artvin",
        "lat": "41.25574151640530",
        "lng": "42.33499667294260",
        "region": "Karadeniz"
    },
    {
        "cityId": "8",
        "city": "Artvin",
        "townId": "1736",
        "town": "Yusufeli",
        "location": "Yusufeli/Artvin",
        "lat": "40.81075288921070",
        "lng": "41.52710864293020",
        "region": "Karadeniz"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "2076",
        "town": "Efeler",
        "location": "Efeler/Aydın (Merkez)",
        "lat": "37.846888798316",
        "lng": "27.816949796874",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1206",
        "town": "Bozdoğan",
        "location": "Bozdoğan/Aydın",
        "lat": "37.67577804169990",
        "lng": "28.31848890467700",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1781",
        "town": "Buharkent",
        "location": "Buharkent/Aydın",
        "lat": "37.96266871303830",
        "lng": "28.73471912143050",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1256",
        "town": "Çine",
        "location": "Çine/Aydın",
        "lat": "37.62679002890240",
        "lng": "28.04288559659710",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "2000",
        "town": "Didim",
        "location": "Didim/Aydın",
        "lat": "37.38230069944730",
        "lng": "27.29079335937650",
        "region": "Ege"
    },
    
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1348",
        "town": "Germencik",
        "location": "Germencik/Aydın",
        "lat": "37.87290324870220",
        "lng": "27.59570933728460",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1807",
        "town": "İncirliova",
        "location": "İncirliova/Aydın",
        "lat": "37.85378712191930",
        "lng": "27.72345558893410",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1435",
        "town": "Karacasu",
        "location": "Karacasu/Aydın",
        "lat": "37.73489910971410",
        "lng": "28.60876527361430",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1957",
        "town": "Karpuzlu",
        "location": "Karpuzlu/Aydın",
        "lat": "37.56180222517430",
        "lng": "27.83577221608440",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1479",
        "town": "Koçarlı",
        "location": "Koçarlı/Aydın",
        "lat": "37.76835951348140",
        "lng": "27.70891697967120",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1968",
        "town": "Köşk",
        "location": "Köşk/Aydın",
        "lat": "37.85079102188080",
        "lng": "28.05252432771460",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1497",
        "town": "Kuşadası",
        "location": "Kuşadası/Aydın",
        "lat": "37.85551523731840",
        "lng": "27.26720260784390",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1498",
        "town": "Kuyucak",
        "location": "Kuyucak/Aydın",
        "lat": "37.90875938919030",
        "lng": "28.44205549997490",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1542",
        "town": "Nazilli",
        "location": "Nazilli/Aydın",
        "lat": "37.90979312210070",
        "lng": "28.32422956403420",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1637",
        "town": "Söke",
        "location": "Söke/Aydın",
        "lat": "37.76656117928210",
        "lng": "27.42293431624550",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1640",
        "town": "Sultanhisar",
        "location": "Sultanhisar/Aydın",
        "lat": "37.88565623840941",
        "lng": "28.15567202970970",
        "region": "Ege"
    },
    {
        "cityId": "9",
        "city": "Aydın",
        "townId": "1724",
        "town": "Yenipazar",
        "location": "Yenipazar/Aydın",
        "lat": "37.82332798011060",
        "lng": "28.19571873536130",
        "region": "Ege"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "2078",
        "town": "Karesi",
        "location": "Karesi/Balıkesir (Merkez)",
        "lat": "39.6439811811706",
        "lng": "27.8848888579952",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "2077",
        "town": "Altıeylül",
        "location": "Altıeylül/Balıkesir",
        "lat": "39.64734123135520",
        "lng": "27.88800796652960",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1161",
        "town": "Ayvalık",
        "location": "Ayvalık/Balıkesir",
        "lat": "39.33574317676320",
        "lng": "26.73838347867270",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1169",
        "town": "Balya",
        "location": "Balya/Balıkesir",
        "lat": "39.74877352586720",
        "lng": "27.57638086844670",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1171",
        "town": "Bandırma",
        "location": "Bandırma/Balıkesir",
        "lat": "40.33414686605670",
        "lng": "27.99264321700630",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1191",
        "town": "Bigadiç",
        "location": "Bigadiç/Balıkesir",
        "lat": "39.40035987774980",
        "lng": "28.12308917567760",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1216",
        "town": "Burhaniye",
        "location": "Burhaniye/Balıkesir",
        "lat": "39.51264161389780",
        "lng": "26.97615549458080",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1291",
        "town": "Dursunbey",
        "location": "Dursunbey/Balıkesir",
        "lat": "39.58011489459100",
        "lng": "28.61040367771430",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1294",
        "town": "Edremit",
        "location": "Edremit/Balıkesir",
        "lat": "39.59238003368101",
        "lng": "27.01219213680500",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1310",
        "town": "Erdek",
        "location": "Erdek/Balıkesir",
        "lat": "40.39923085812100",
        "lng": "27.80085707405750",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1928",
        "town": "Gömeç",
        "location": "Gömeç/Balıkesir",
        "lat": "39.38191159015310",
        "lng": "26.83129473652880",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1360",
        "town": "Gönen",
        "location": "Gönen/Balıkesir",
        "lat": "40.11445138252050",
        "lng": "27.65897475206920",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1384",
        "town": "Havran",
        "location": "Havran/Balıkesir",
        "lat": "39.55222814014960",
        "lng": "27.10141775037780",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1418",
        "town": "İvrindi",
        "location": "İvrindi/Balıkesir",
        "lat": "39.59647651744690",
        "lng": "27.49272101641410",
        "region": "Marmara"
    },
    
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1462",
        "town": "Kepsut",
        "location": "Kepsut/Balıkesir",
        "lat": "39.68643146467210",
        "lng": "28.15178229990450",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1514",
        "town": "Manyas",
        "location": "Manyas/Balıkesir",
        "lat": "40.05195522566880",
        "lng": "27.98030120316840",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1824",
        "town": "Marmara",
        "location": "Marmara/Balıkesir",
        "lat": "40.58375257932940",
        "lng": "27.56273381067670",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1608",
        "town": "Savaştepe",
        "location": "Savaştepe/Balıkesir",
        "lat": "39.37927394995190",
        "lng": "27.64639472275690",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1619",
        "town": "Sındırgı",
        "location": "Sındırgı/Balıkesir",
        "lat": "39.24917517698620",
        "lng": "28.17695826103830",
        "region": "Marmara"
    },
    {
        "cityId": "10",
        "city": "Balıkesir",
        "townId": "1644",
        "town": "Susurluk",
        "location": "Susurluk/Balıkesir",
        "lat": "39.91600201410830",
        "lng": "28.16088815222980",
        "region": "Marmara"
    },
    {
        "cityId": "74",
        "city": "Bartın",
        "townId": "1172",
        "town": "Merkez",
        "location": "Merkez/Bartın",
        "lat": "41.6267556402687",
        "lng": "32.3541805173736",
        "region": "Karadeniz"
    },
    {
        "cityId": "74",
        "city": "Bartın",
        "townId": "1761",
        "town": "Amasra",
        "location": "Amasra/Bartın",
        "lat": "41.74458328177181",
        "lng": "32.37974511424251",
        "region": "Karadeniz"
    },
    {
        "cityId": "74",
        "city": "Bartın",
        "townId": "1496",
        "town": "Kurucaşile",
        "location": "Kurucaşile/Bartın",
        "lat": "41.84388049017420",
        "lng": "32.72058593809040",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "74",
        "city": "Bartın",
        "townId": "1701",
        "town": "Ulus",
        "location": "Ulus/Bartın",
        "lat": "41.58350623001230",
        "lng": "32.63969423975970",
        "region": "Karadeniz"
    },
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1174",
        "town": "Merkez",
        "location": "Merkez/Batman",
        "lat": "37.9051593104812",
        "lng": "41.1320974633047",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1184",
        "town": "Beşiri",
        "location": "Beşiri/Batman",
        "lat": "37.92037876459570",
        "lng": "41.29112165782090",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1345",
        "town": "Gercüş",
        "location": "Gercüş/Batman",
        "lat": "37.56822218238900",
        "lng": "41.37995566950700",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1941",
        "town": "Hasankeyf",
        "location": "Hasankeyf/Batman",
        "lat": "37.73896550266290",
        "lng": "41.40690212748080",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1487",
        "town": "Kozluk",
        "location": "Kozluk/Batman",
        "lat": "38.16646335585950",
        "lng": "41.50107102042020",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "72",
        "city": "Batman",
        "townId": "1607",
        "town": "Sason",
        "location": "Sason/Batman",
        "lat": "38.34058930247680",
        "lng": "41.41008659438830",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "69",
        "city": "Bayburt",
        "townId": "1176",
        "town": "Merkez",
        "location": "Merkez/Bayburt",
        "lat": "40.2489522210268",
        "lng": "40.2315640908591",
        "region": "Karadeniz"
    },
    {
        "cityId": "69",
        "city": "Bayburt",
        "townId": "1767",
        "town": "Aydıntepe",
        "location": "Aydıntepe/Bayburt",
        "lat": "40.38897190824791",
        "lng": "40.14734545148910",
        "region": "Karadeniz"
    },
    {
        "cityId": "69",
        "city": "Bayburt",
        "townId": "1788",
        "town": "Demirözü",
        "location": "Demirözü/Bayburt",
        "lat": "40.16335742800110",
        "lng": "39.89301056721900",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1192",
        "town": "Merkez",
        "location": "Merkez/Bilecik",
        "lat": "40.1425710981427",
        "lng": "29.9793219547932",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1210",
        "town": "Bozüyük",
        "location": "Bozüyük/Bilecik",
        "lat": "39.90678163816060",
        "lng": "30.03460548704650",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1359",
        "town": "Gölpazarı",
        "location": "Gölpazarı/Bilecik",
        "lat": "40.27884095262850",
        "lng": "30.29678827020970",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1948",
        "town": "İnhisar",
        "location": "İnhisar/Bilecik",
        "lat": "40.05594030088890",
        "lng": "30.38465469523700",
        "region": "Marmara"
    },
    
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1559",
        "town": "Osmaneli",
        "location": "Osmaneli/Bilecik",
        "lat": "40.35220779564041",
        "lng": "30.02940566928460",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1571",
        "town": "Pazaryeri",
        "location": "Pazaryeri/Bilecik",
        "lat": "39.99689654005200",
        "lng": "29.91668439308720",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1636",
        "town": "Söğüt",
        "location": "Söğüt/Bilecik",
        "lat": "40.02835243225190",
        "lng": "30.18067719625950",
        "region": "Marmara"
    },
    {
        "cityId": "11",
        "city": "Bilecik",
        "townId": "1857",
        "town": "Yenipazar",
        "location": "Yenipazar/Bilecik",
        "lat": "40.17957402844280",
        "lng": "30.51027523748930",
        "region": "Marmara"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1193",
        "town": "Merkez",
        "location": "Merkez/Bingöl",
        "lat": "38.8964500896973",
        "lng": "40.5046036835951",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1750",
        "town": "Adaklı",
        "location": "Adaklı/Bingöl",
        "lat": "39.22847497636900",
        "lng": "40.48215015038590",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1344",
        "town": "Genç",
        "location": "Genç/Bingöl",
        "lat": "38.74837525040740",
        "lng": "40.55344564335840",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1446",
        "town": "Karlıova",
        "location": "Karlıova/Bingöl",
        "lat": "39.28936010145200",
        "lng": "41.00686554090860",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1475",
        "town": "Kiğı",
        "location": "Kiğı/Bingöl",
        "lat": "39.29976235718710",
        "lng": "40.34804865362510",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1633",
        "town": "Solhan",
        "location": "Solhan/Bingöl",
        "lat": "38.95391285315180",
        "lng": "41.02427719442350",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1855",
        "town": "Yayladere",
        "location": "Yayladere/Bingöl",
        "lat": "39.22587369027940",
        "lng": "40.06526991176820",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "12",
        "city": "Bingöl",
        "townId": "1996",
        "town": "Yedisu",
        "location": "Yedisu/Bingöl",
        "lat": "39.43391031256100",
        "lng": "40.54526458738551",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1196",
        "town": "Merkez",
        "location": "Merkez/Bitlis",
        "lat": "38.3737624168365",
        "lng": "42.0974615553232",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1106",
        "town": "Adilcevaz",
        "location": "Adilcevaz/Bitlis",
        "lat": "38.79806736191570",
        "lng": "42.74004849857301",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1112",
        "town": "Ahlat",
        "location": "Ahlat/Bitlis",
        "lat": "38.74319618939640",
        "lng": "42.46582556965240",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1798",
        "town": "Güroymak",
        "location": "Güroymak/Bitlis",
        "lat": "38.56691091884860",
        "lng": "42.05968290745151",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1394",
        "town": "Hizan",
        "location": "Hizan/Bitlis",
        "lat": "38.22046078443310",
        "lng": "42.40046311386710",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1537",
        "town": "Mutki",
        "location": "Mutki/Bitlis",
        "lat": "38.41445163393910",
        "lng": "41.92217156103650",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "13",
        "city": "Bitlis",
        "townId": "1669",
        "town": "Tatvan",
        "location": "Tatvan/Bitlis",
        "lat": "38.52494686692940",
        "lng": "42.27510816409860",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1199",
        "town": "Merkez",
        "location": "Merkez/Bolu",
        "lat": "40,7389570404505",
        "lng": "31,6103343266054",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1916",
        "town": "Dörtdivan",
        "location": "Dörtdivan/Bolu",
        "lat": "40.72073511929890",
        "lng": "32.06264952371990",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1346",
        "town": "Gerede",
        "location": "Gerede/Bolu",
        "lat": "40.79145986776510",
        "lng": "32.20827148595670",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1364",
        "town": "Göynük",
        "location": "Göynük/Bolu",
        "lat": "40.41151480533070",
        "lng": "30.80355702857590",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1466",
        "town": "Kıbrıscık",
        "location": "Kıbrıscık/Bolu",
        "lat": "40.41310862462480",
        "lng": "31.84520237245420",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1522",
        "town": "Mengen",
        "location": "Mengen/Bolu",
        "lat": "40.92695470134410",
        "lng": "32.07155563340190",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1531",
        "town": "Mudurnu",
        "location": "Mudurnu/Bolu",
        "lat": "40.48980524969080",
        "lng": "31.20200789332930",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1610",
        "town": "Seben",
        "location": "Seben/Bolu",
        "lat": "40.41577698692710",
        "lng": "31.57595434687750",
        "region": "Karadeniz"
    },
    {
        "cityId": "14",
        "city": "Bolu",
        "townId": "1997",
        "town": "Yeniçağa",
        "location": "Yeniçağa/Bolu",
        "lat": "40.77138295430391",
        "lng": "32.02979435380211",
        "region": "Karadeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1215",
        "town": "Merkez",
        "location": "Merkez/Burdur",
        "lat": "37,7111915951103",
        "lng": "30,2884810491243",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1109",
        "town": "Ağlasun",
        "location": "Ağlasun/Burdur",
        "lat": "37.64783114262850",
        "lng": "30.53577591116940",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1874",
        "town": "Altınyayla",
        "location": "Altınyayla/Burdur",
        "lat": "37.00627224207571",
        "lng": "29.54413133819400",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1211",
        "town": "Bucak",
        "location": "Bucak/Burdur",
        "lat": "37.47463731045080",
        "lng": "30.56432303224430",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1899",
        "town": "Çavdır",
        "location": "Çavdır/Burdur",
        "lat": "37.15822366704290",
        "lng": "29.67789531181130",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1903",
        "town": "Çeltikçi",
        "location": "Çeltikçi/Burdur",
        "lat": "37.53380164425470",
        "lng": "30.48261619861910",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1357",
        "town": "Gölhisar",
        "location": "Gölhisar/Burdur",
        "lat": "37.14133677620090",
        "lng": "29.51345784908650",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1813",
        "town": "Karamanlı",
        "location": "Karamanlı/Burdur",
        "lat": "37.37441907546140",
        "lng": "29.83266876097810",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1816",
        "town": "Kemer",
        "location": "Kemer/Burdur",
        "lat": "37.35742066026360",
        "lng": "30.05979335589370",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1672",
        "town": "Tefenni",
        "location": "Tefenni/Burdur",
        "lat": "37.31736470494960",
        "lng": "29.78094166324020",
        "region": "Akdeniz"
    },
    {
        "cityId": "15",
        "city": "Burdur",
        "townId": "1728",
        "town": "Yeşilova",
        "location": "Yeşilova/Burdur",
        "lat": "37.50144486731260",
        "lng": "29.76189893840040",
        "region": "Akdeniz"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1832",
        "town": "Osmangazi",
        "location": "Osmangazi/Bursa (Merkez)",
        "lat": "40.1973324364148",
        "lng": "29.0623636636427",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1783",
        "town": "Büyükorhan",
        "location": "Büyükorhan/Bursa",
        "lat": "39.77677434162510",
        "lng": "28.88918109442090",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1343",
        "town": "Gemlik",
        "location": "Gemlik/Bursa",
        "lat": "40.42703741356170",
        "lng": "29.16996112085670",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1935",
        "town": "Gürsu",
        "location": "Gürsu/Bursa",
        "lat": "40.19890787173250",
        "lng": "29.18307115849630",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1799",
        "town": "Harmancık",
        "location": "Harmancık/Bursa",
        "lat": "39.67513926385320",
        "lng": "29.14593679764230",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1411",
        "town": "İnegöl",
        "location": "İnegöl/Bursa",
        "lat": "40.08681730256290",
        "lng": "29.51336033526870",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1420",
        "town": "İznik",
        "location": "İznik/Bursa",
        "lat": "40.41925874287940",
        "lng": "29.71783960070990",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1434",
        "town": "Karacabey",
        "location": "Karacabey/Bursa",
        "lat": "40.18536857923430",
        "lng": "28.35513552109060",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1457",
        "town": "Keles",
        "location": "Keles/Bursa",
        "lat": "39.92016686417090",
        "lng": "29.22388965639050",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1960",
        "town": "Kestel",
        "location": "Kestel/Bursa",
        "lat": "40.19880369577750",
        "lng": "29.20033076079530",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1530",
        "town": "Mudanya",
        "location": "Mudanya/Bursa",
        "lat": "40.34508425309650",
        "lng": "28.92325675509700",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1535",
        "town": "Mustafakemalpaşa",
        "location": "Mustafakemalpaşa/Bursa",
        "lat": "40.03368726667330",
        "lng": "28.37202329011290",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1829",
        "town": "Nilüfer",
        "location": "Nilüfer/Bursa",
        "lat": "40.21141738964701",
        "lng": "28.97764597270080",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1553",
        "town": "Orhaneli",
        "location": "Orhaneli/Bursa",
        "lat": "39.91105436477920",
        "lng": "28.98365770259190",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1554",
        "town": "Orhangazi",
        "location": "Orhangazi/Bursa",
        "lat": "40.49008888508580",
        "lng": "29.31109868374360",
        "region": "Marmara"
    },
    
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1725",
        "town": "Yenişehir",
        "location": "Yenişehir/Bursa",
        "lat": "40.26666068183180",
        "lng": "29.62894395285390",
        "region": "Marmara"
    },
    {
        "cityId": "16",
        "city": "Bursa",
        "townId": "1859",
        "town": "Yıldırım",
        "location": "Yıldırım/Bursa",
        "lat": "40.19159999468590",
        "lng": "29.11124272451170",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1230",
        "town": "Merkez",
        "location": "Merkez/Çanakkale",
        "lat": "40,1477215078146",
        "lng": "26,4537145292227",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1160",
        "town": "Ayvacık",
        "location": "Ayvacık/Çanakkale",
        "lat": "39.61304995110010",
        "lng": "26.41000083886800",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1180",
        "town": "Bayramiç",
        "location": "Bayramiç/Çanakkale",
        "lat": "39.81245833935190",
        "lng": "26.59734384631140",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1190",
        "town": "Biga",
        "location": "Biga/Çanakkale",
        "lat": "40.23714604495460",
        "lng": "27.23697857796090",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1205",
        "town": "Bozcaada",
        "location": "Bozcaada/Çanakkale",
        "lat": "39.83448592737780",
        "lng": "26.07297444170460",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1229",
        "town": "Çan",
        "location": "Çan/Çanakkale",
        "lat": "40.02507335384440",
        "lng": "27.04978413788480",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1293",
        "town": "Eceabat",
        "location": "Eceabat/Çanakkale",
        "lat": "40.19062220857110",
        "lng": "26.35676444174640",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1326",
        "town": "Ezine",
        "location": "Ezine/Çanakkale",
        "lat": "39.78570449745700",
        "lng": "26.34340902155220",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1340",
        "town": "Gelibolu",
        "location": "Gelibolu/Çanakkale",
        "lat": "40.42218664396430",
        "lng": "26.66875394164600",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1408",
        "town": "Gökçeada",
        "location": "Gökçeada/Çanakkale",
        "lat": "40.23442414158341",
        "lng": "25.94783038689090",
        "region": "Marmara"
    },
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1503",
        "town": "Lapseki",
        "location": "Lapseki/Çanakkale",
        "lat": "40.34729237385800",
        "lng": "26.68491368573220",
        "region": "Marmara"
    },
    
    {
        "cityId": "17",
        "city": "Çanakkale",
        "townId": "1722",
        "town": "Yenice",
        "location": "Yenice/Çanakkale",
        "lat": "39.93328976501050",
        "lng": "27.24568280803030",
        "region": "Marmara"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1232",
        "town": "Merkez",
        "location": "Merkez/Çankırı",
        "lat": "40,5972796949561",
        "lng": "33,6153388077035",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1765",
        "town": "Atkaracalar",
        "location": "Atkaracalar/Çankırı",
        "lat": "40.80792541151390",
        "lng": "33.07784078010920",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1885",
        "town": "Bayramören",
        "location": "Bayramören/Çankırı",
        "lat": "40.94395024776640",
        "lng": "33.20583020311320",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1248",
        "town": "Çerkeş",
        "location": "Çerkeş/Çankırı",
        "lat": "40.81752740621530",
        "lng": "32.89295323881020",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1300",
        "town": "Eldivan",
        "location": "Eldivan/Çankırı",
        "lat": "40.52557410294580",
        "lng": "33.49439130760161",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1399",
        "town": "Ilgaz",
        "location": "Ilgaz/Çankırı",
        "lat": "40.92664891016571",
        "lng": "33.63883212418570",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1817",
        "town": "Kızılırmak",
        "location": "Kızılırmak/Çankırı",
        "lat": "40.34962712744661",
        "lng": "33.98686426866440",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1963",
        "town": "Korgun",
        "location": "Korgun/Çankırı",
        "lat": "40.73623693906690",
        "lng": "33.51971473313010",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1494",
        "town": "Kurşunlu",
        "location": "Kurşunlu/Çankırı",
        "lat": "40.84092046864510",
        "lng": "33.27329469764130",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1555",
        "town": "Orta",
        "location": "Orta/Çankırı",
        "lat": "40.61979812697300",
        "lng": "33.11137635007910",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1649",
        "town": "Şabanözü",
        "location": "Şabanözü/Çankırı",
        "lat": "40.47218398681840",
        "lng": "33.28643795286451",
        "region": "İç Anadolu"
    },
    {
        "cityId": "18",
        "city": "Çankırı",
        "townId": "1718",
        "town": "Yapraklı",
        "location": "Yapraklı/Çankırı",
        "lat": "40.75488252097860",
        "lng": "33.78100053186510",
        "region": "İç Anadolu"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1259",
        "town": "Merkez",
        "location": "Merkez/Çorum",
        "lat": "40,5531318121985",
        "lng": "34,9307945619675",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1124",
        "town": "Alaca",
        "location": "Alaca/Çorum",
        "lat": "40.17807894871180",
        "lng": "34.84868413025990",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1177",
        "town": "Bayat",
        "location": "Bayat/Çorum",
        "lat": "40.63506036004590",
        "lng": "34.27719868833170",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1778",
        "town": "Boğazkale",
        "location": "Boğazkale/Çorum",
        "lat": "40.02648549240960",
        "lng": "34.60730833777950",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1911",
        "town": "Dodurga",
        "location": "Dodurga/Çorum",
        "lat": "40.85198960042410",
        "lng": "34.82704853655440",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1414",
        "town": "İskilip",
        "location": "İskilip/Çorum",
        "lat": "40.72056223660180",
        "lng": "34.48230667279820",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1445",
        "town": "Kargı",
        "location": "Kargı/Çorum",
        "lat": "41.13690250573150",
        "lng": "34.47850269883040",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1972",
        "town": "Laçin",
        "location": "Laçin/Çorum",
        "lat": "40.76541037791250",
        "lng": "34.90644965879811",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1520",
        "town": "Mecitözü",
        "location": "Mecitözü/Çorum",
        "lat": "40.53326393644511",
        "lng": "35.28315884130960",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1976",
        "town": "Oğuzlar",
        "location": "Oğuzlar/Çorum",
        "lat": "40.75712853511530",
        "lng": "34.70106336725720",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1556",
        "town": "Ortaköy",
        "location": "Ortaköy/Çorum",
        "lat": "40.27217465268990",
        "lng": "35.23706767747440",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1558",
        "town": "Osmancık",
        "location": "Osmancık/Çorum",
        "lat": "40.97139692563510",
        "lng": "34.82370344048030",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1642",
        "town": "Sungurlu",
        "location": "Sungurlu/Çorum",
        "lat": "40.17452025210960",
        "lng": "34.40826034602820",
        "region": "Karadeniz"
    },
    {
        "cityId": "19",
        "city": "Çorum",
        "townId": "1850",
        "town": "Uğurludağ",
        "location": "Uğurludağ/Çorum",
        "lat": "40.45033604666690",
        "lng": "34.44145112583250",
        "region": "Karadeniz"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "2079",
        "town": "Merkezefendi",
        "location": "Merkezefendi/Denizli (Merkez)",
        "lat": "37.7998191364029",
        "lng": "29.0612535860973",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1102",
        "town": "Acıpayam",
        "location": "Acıpayam/Denizli",
        "lat": "37.43996540599420",
        "lng": "29.34856669530150",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1769",
        "town": "Babadağ",
        "location": "Babadağ/Denizli",
        "lat": "37.81435434337720",
        "lng": "28.86304303817440",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1881",
        "town": "Baklan",
        "location": "Baklan/Denizli",
        "lat": "37.97669083972590",
        "lng": "29.59539501906940",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1774",
        "town": "Bekilli",
        "location": "Bekilli/Denizli",
        "lat": "38.22176014636350",
        "lng": "29.41296914222460",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1888",
        "town": "Beyağaç",
        "location": "Beyağaç/Denizli",
        "lat": "37.23694076093431",
        "lng": "28.90096999190270",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1889",
        "town": "Bozkurt",
        "location": "Bozkurt/Denizli",
        "lat": "37.82809061805250",
        "lng": "29.61033599584930",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1214",
        "town": "Buldan",
        "location": "Buldan/Denizli",
        "lat": "38.03896261610660",
        "lng": "28.85008281540760",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1224",
        "town": "Çal",
        "location": "Çal/Denizli",
        "lat": "38.07921286900220",
        "lng": "29.40013168477590",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1226",
        "town": "Çameli",
        "location": "Çameli/Denizli",
        "lat": "37.07976235711350",
        "lng": "29.35829696305840",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1233",
        "town": "Çardak",
        "location": "Çardak/Denizli",
        "lat": "37.82910839537250",
        "lng": "29.58827844857560",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1257",
        "town": "Çivril",
        "location": "Çivril/Denizli",
        "lat": "38.29618721681800",
        "lng": "29.72581657382650",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1371",
        "town": "Güney",
        "location": "Güney/Denizli",
        "lat": "38.15420059620820",
        "lng": "29.05390499512370",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1803",
        "town": "Honaz",
        "location": "Honaz/Denizli",
        "lat": "37.75691122344460",
        "lng": "29.26441215134500",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1426",
        "town": "Kale",
        "location": "Kale/Denizli",
        "lat": "37.45388035452941",
        "lng": "28.85514048689050",
        "region": "Ege"
    },
    
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1871",
        "town": "Pamukkale",
        "location": "Pamukkale/Denizli",
        "lat": "37.78127676306010",
        "lng": "29.08450259747710",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1597",
        "town": "Sarayköy",
        "location": "Sarayköy/Denizli",
        "lat": "37.91703909168640",
        "lng": "28.93375810186170",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1840",
        "town": "Serinhisar",
        "location": "Serinhisar/Denizli",
        "lat": "37.58996730946910",
        "lng": "29.26660249342860",
        "region": "Ege"
    },
    {
        "cityId": "20",
        "city": "Denizli",
        "townId": "1670",
        "town": "Tavas",
        "location": "Tavas/Denizli",
        "lat": "37.57208123957120",
        "lng": "29.07875196389410",
        "region": "Ege"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "2043",
        "town": "Yenişehir",
        "location": "Yenişehir/Diyarbakır (Merkez)",
        "lat": "37.936785529001",
        "lng": "40.2076648221053",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "2040",
        "town": "Bağlar",
        "location": "Bağlar/Diyarbakır",
        "lat": "37.93675035011821",
        "lng": "40.20765912740730",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1195",
        "town": "Bismil",
        "location": "Bismil/Diyarbakır",
        "lat": "37.84294131543300",
        "lng": "40.65967160715001",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1249",
        "town": "Çermik",
        "location": "Çermik/Diyarbakır",
        "lat": "38.13955674510100",
        "lng": "39.47202739712630",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1253",
        "town": "Çınar",
        "location": "Çınar/Diyarbakır",
        "lat": "37.72415728094311",
        "lng": "40.41357158154410",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1263",
        "town": "Çüngüş",
        "location": "Çüngüş/Diyarbakır",
        "lat": "38.21229886136410",
        "lng": "39.28840866065310",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1278",
        "town": "Dicle",
        "location": "Dicle/Diyarbakır",
        "lat": "38.36777365142610",
        "lng": "40.07136588691320",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1791",
        "town": "Eğil",
        "location": "Eğil/Diyarbakır",
        "lat": "38.25671690557890",
        "lng": "40.07647728529330",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1315",
        "town": "Ergani",
        "location": "Ergani/Diyarbakır",
        "lat": "38.26489891068260",
        "lng": "39.75925521475690",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1381",
        "town": "Hani",
        "location": "Hani/Diyarbakır",
        "lat": "38.40452186607400",
        "lng": "40.40007103994280",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1389",
        "town": "Hazro",
        "location": "Hazro/Diyarbakır",
        "lat": "38.25360391147840",
        "lng": "40.78082300410940",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "2041",
        "town": "Kayapınar",
        "location": "Kayapınar/Diyarbakır",
        "lat": "37.93678856655180",
        "lng": "40.20761643454530",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1962",
        "town": "Kocaköy",
        "location": "Kocaköy/Diyarbakır",
        "lat": "38.29313472991690",
        "lng": "40.50777374025220",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1490",
        "town": "Kulp",
        "location": "Kulp/Diyarbakır",
        "lat": "38.49409808511750",
        "lng": "41.01240606539240",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1504",
        "town": "Lice",
        "location": "Lice/Diyarbakır",
        "lat": "38.45167800229430",
        "lng": "40.64297283697530",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "1624",
        "town": "Silvan",
        "location": "Silvan/Diyarbakır",
        "lat": "38.14119094391171",
        "lng": "41.01293184474910",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "21",
        "city": "Diyarbakır",
        "townId": "2042",
        "town": "Sur",
        "location": "Sur/Diyarbakır",
        "lat": "37.91085103804771",
        "lng": "40.22779931875430",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1292",
        "town": "Merkez",
        "location": "Merkez/Düzce",
        "lat": "40,837577435194",
        "lng": "31,1739108165221",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1116",
        "town": "Akçakoca",
        "location": "Akçakoca/Düzce",
        "lat": "41.07720037441290",
        "lng": "31.12299644264650",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1784",
        "town": "Cumayeri",
        "location": "Cumayeri/Düzce",
        "lat": "40.86366991403640",
        "lng": "30.95307357355170",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1905",
        "town": "Çilimli",
        "location": "Çilimli/Düzce",
        "lat": "40.88720400460480",
        "lng": "31.04517754173910",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1794",
        "town": "Gölyaka",
        "location": "Gölyaka/Düzce",
        "lat": "40.78555932452220",
        "lng": "30.99440118119340",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "2017",
        "town": "Gümüşova",
        "location": "Gümüşova/Düzce",
        "lat": "40.84574940109961",
        "lng": "30.93857871426880",
        "region": "Karadeniz"
    },
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "2031",
        "town": "Kaynaşlı",
        "location": "Kaynaşlı/Düzce",
        "lat": "40.77353359254470",
        "lng": "31.31945692664560",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "81",
        "city": "Düzce",
        "townId": "1730",
        "town": "Yığılca",
        "location": "Yığılca/Düzce",
        "lat": "40.96058316896860",
        "lng": "31.44445064885660",
        "region": "Karadeniz"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1295",
        "town": "Merkez",
        "location": "Merkez/Edirne",
        "lat": "41,6504972682056",
        "lng": "26,5933177840823",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1307",
        "town": "Enez",
        "location": "Enez/Edirne",
        "lat": "40.72383200719460",
        "lng": "26.09068118231200",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1385",
        "town": "Havsa",
        "location": "Havsa/Edirne",
        "lat": "41.54355411243720",
        "lng": "26.81992093030760",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1412",
        "town": "İpsala",
        "location": "İpsala/Edirne",
        "lat": "40.90662225706750",
        "lng": "26.37426268109570",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1464",
        "town": "Keşan",
        "location": "Keşan/Edirne",
        "lat": "40.85856116027370",
        "lng": "26.62191754980130",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1502",
        "town": "Lalapaşa",
        "location": "Lalapaşa/Edirne",
        "lat": "41.83938021385601",
        "lng": "26.73375829726450",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1523",
        "town": "Meriç",
        "location": "Meriç/Edirne",
        "lat": "41.19257716889620",
        "lng": "26.42114651503760",
        "region": "Marmara"
    },
    
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1988",
        "town": "Süloğlu",
        "location": "Süloğlu/Edirne",
        "lat": "41.76473726667000",
        "lng": "26.90741689471970",
        "region": "Marmara"
    },
    {
        "cityId": "22",
        "city": "Edirne",
        "townId": "1705",
        "town": "Uzunköprü",
        "location": "Uzunköprü/Edirne",
        "lat": "41.26084103925750",
        "lng": "26.71148989853140",
        "region": "Marmara"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1298",
        "town": "Merkez",
        "location": "Merkez/Elazığ",
        "lat": "38,6662296687403",
        "lng": "39,2227360599137",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1110",
        "town": "Ağın",
        "location": "Ağın/Elazığ",
        "lat": "38.94406923474020",
        "lng": "38.71371761639180",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1873",
        "town": "Alacakaya",
        "location": "Alacakaya/Elazığ",
        "lat": "38.46201675347150",
        "lng": "39.86231755180770",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1762",
        "town": "Arıcak",
        "location": "Arıcak/Elazığ",
        "lat": "38.55707239664150",
        "lng": "40.13871482541790",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1173",
        "town": "Baskil",
        "location": "Baskil/Elazığ",
        "lat": "38.56781170733090",
        "lng": "38.82377027512220",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1438",
        "town": "Karakoçan",
        "location": "Karakoçan/Elazığ",
        "lat": "38.95319926332610",
        "lng": "40.03818823687790",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1455",
        "town": "Keban",
        "location": "Keban/Elazığ",
        "lat": "38.79568786577430",
        "lng": "38.73561322873150",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1820",
        "town": "Kovancılar",
        "location": "Kovancılar/Elazığ",
        "lat": "38.71777429760350",
        "lng": "39.86654700102760",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1506",
        "town": "Maden",
        "location": "Maden/Elazığ",
        "lat": "38.39326250711850",
        "lng": "39.67413061446940",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1566",
        "town": "Palu",
        "location": "Palu/Elazığ",
        "lat": "38.69518211926190",
        "lng": "39.93106552484890",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "23",
        "city": "Elazığ",
        "townId": "1631",
        "town": "Sivrice",
        "location": "Sivrice/Elazığ",
        "lat": "38.44918379934780",
        "lng": "39.30438096140810",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1318",
        "town": "Merkez",
        "location": "Merkez/Erzincan",
        "lat": "39,7467444427483",
        "lng": "39,4910566212566",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1243",
        "town": "Çayırlı",
        "location": "Çayırlı/Erzincan",
        "lat": "39.81134879134190",
        "lng": "40.04718309568550",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1406",
        "town": "İliç",
        "location": "İliç/Erzincan",
        "lat": "39.46910754589171",
        "lng": "38.56260632056840",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1459",
        "town": "Kemah",
        "location": "Kemah/Erzincan",
        "lat": "39.60339240777381",
        "lng": "39.03399750477090",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1460",
        "town": "Kemaliye",
        "location": "Kemaliye/Erzincan",
        "lat": "39.26154550863200",
        "lng": "38.49688626104460",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1977",
        "town": "Otlukbeli",
        "location": "Otlukbeli/Erzincan",
        "lat": "39.97098901925110",
        "lng": "40.02582375801051",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1583",
        "town": "Refahiye",
        "location": "Refahiye/Erzincan",
        "lat": "39.90665752495020",
        "lng": "38.77472587043701",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1675",
        "town": "Tercan",
        "location": "Tercan/Erzincan",
        "lat": "39.77652968759720",
        "lng": "40.38295164143390",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "24",
        "city": "Erzincan",
        "townId": "1853",
        "town": "Üzümlü",
        "location": "Üzümlü/Erzincan",
        "lat": "39.67946120209930",
        "lng": "39.67012783966520",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1945",
        "town": "Aziziye",
        "location": "Aziziye/Erzurum (Merkez)",
        "lat": "39.9433365868411",
        "lng": "41.1120967477641",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1153",
        "town": "Aşkale",
        "location": "Aşkale/Erzurum",
        "lat": "39.91858492998800",
        "lng": "40.68283898330050",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1235",
        "town": "Çat",
        "location": "Çat/Erzurum",
        "lat": "39.61113816972530",
        "lng": "40.98163997241170",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1392",
        "town": "Hınıs",
        "location": "Hınıs/Erzurum",
        "lat": "39.35745252725110",
        "lng": "41.71341125446160",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1396",
        "town": "Horasan",
        "location": "Horasan/Erzurum",
        "lat": "40.03722162142610",
        "lng": "42.16367461415210",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1416",
        "town": "İspir",
        "location": "İspir/Erzurum",
        "lat": "40.48329283393490",
        "lng": "40.99453554944570",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1812",
        "town": "Karaçoban",
        "location": "Karaçoban/Erzurum",
        "lat": "39.34640090823570",
        "lng": "42.09661958666280",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1444",
        "town": "Karayazı",
        "location": "Karayazı/Erzurum",
        "lat": "39.70165450590320",
        "lng": "42.14306521886941",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1967",
        "town": "Köprüköy",
        "location": "Köprüköy/Erzurum",
        "lat": "39.96702572329970",
        "lng": "41.87155097343100",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1540",
        "town": "Narman",
        "location": "Narman/Erzurum",
        "lat": "40.34446010717890",
        "lng": "41.86859563869821",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1550",
        "town": "Oltu",
        "location": "Oltu/Erzurum",
        "lat": "40.54542638466370",
        "lng": "41.99301507968360",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1551",
        "town": "Olur",
        "location": "Olur/Erzurum",
        "lat": "40.82732977888220",
        "lng": "42.12999082283941",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "2044",
        "town": "Palandöken",
        "location": "Palandöken/Erzurum",
        "lat": "39.90043304322400",
        "lng": "41.26603783249570",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1567",
        "town": "Pasinler",
        "location": "Pasinler/Erzurum",
        "lat": "39.97712415485910",
        "lng": "41.66817357884200",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1865",
        "town": "Pazaryolu",
        "location": "Pazaryolu/Erzurum",
        "lat": "40.41619488985340",
        "lng": "40.77483716963140",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1657",
        "town": "Şenkaya",
        "location": "Şenkaya/Erzurum",
        "lat": "40.56519794290850",
        "lng": "42.34333584912080",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1674",
        "town": "Tekman",
        "location": "Tekman/Erzurum",
        "lat": "39.64927561338360",
        "lng": "41.51170887120990",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1683",
        "town": "Tortum",
        "location": "Tortum/Erzurum",
        "lat": "40.29475640850020",
        "lng": "41.54666873049200",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "1851",
        "town": "Uzundere",
        "location": "Uzundere/Erzurum",
        "lat": "40.53201711384191",
        "lng": "41.54365342693940",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "25",
        "city": "Erzurum",
        "townId": "2045",
        "town": "Yakutiye",
        "location": "Yakutiye/Erzurum",
        "lat": "39.90501421979250",
        "lng": "41.25649843067980",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "2046",
        "town": "Odunpazarı",
        "location": "Odunpazarı/Eskişehir (Merkez)",
        "lat": "39.7653151871548",
        "lng": "30.5198745935232",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1759",
        "town": "Alpu",
        "location": "Alpu/Eskişehir",
        "lat": "39.76830633161430",
        "lng": "30.95968174588910",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1777",
        "town": "Beylikova",
        "location": "Beylikova/Eskişehir",
        "lat": "39.69422150762570",
        "lng": "31.20452933046600",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1255",
        "town": "Çifteler",
        "location": "Çifteler/Eskişehir",
        "lat": "39.38055326558451",
        "lng": "31.05054547785850",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1934",
        "town": "Günyüzü",
        "location": "Günyüzü/Eskişehir",
        "lat": "39.38739410096310",
        "lng": "31.81197811067410",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1939",
        "town": "Han",
        "location": "Han/Eskişehir",
        "lat": "39.15853659495670",
        "lng": "30.86350835776730",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1808",
        "town": "İnönü",
        "location": "İnönü/Eskişehir",
        "lat": "39.82332717481100",
        "lng": "30.14460222232580",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1508",
        "town": "Mahmudiye",
        "location": "Mahmudiye/Eskişehir",
        "lat": "39.50059472399640",
        "lng": "30.98218771908940",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1973",
        "town": "Mihalgazi",
        "location": "Mihalgazi/Eskişehir",
        "lat": "40.02689679470510",
        "lng": "30.57518164646860",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1527",
        "town": "Mihalıççık",
        "location": "Mihalıççık/Eskişehir",
        "lat": "39.86294570808451",
        "lng": "31.49331469284110",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1599",
        "town": "Sarıcakaya",
        "location": "Sarıcakaya/Eskişehir",
        "lat": "40.03764769588860",
        "lng": "30.62070074896780",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1618",
        "town": "Seyitgazi",
        "location": "Seyitgazi/Eskişehir",
        "lat": "39.44563484916440",
        "lng": "30.69389258567960",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "1632",
        "town": "Sivrihisar",
        "location": "Sivrihisar/Eskişehir",
        "lat": "39.43642369110290",
        "lng": "31.52984282477920",
        "region": "İç Anadolu"
    },
    {
        "cityId": "26",
        "city": "Eskişehir",
        "townId": "2047",
        "town": "Tepebaşı",
        "location": "Tepebaşı/Eskişehir",
        "lat": "39.79005220009610",
        "lng": "30.50573352761970",
        "region": "İç Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1844",
        "town": "Şehitkamil",
        "location": "Şehitkamil/Gaziantep (Merkez)",
        "lat": "37.0576089189934",
        "lng": "37.3796431173882",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1139",
        "town": "Araban",
        "location": "Araban/Gaziantep",
        "lat": "37.42430208221571",
        "lng": "37.67660148289130",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1415",
        "town": "İslahiye",
        "location": "İslahiye/Gaziantep",
        "lat": "37.02650885976751",
        "lng": "36.64639300894460",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1956",
        "town": "Karkamış",
        "location": "Karkamış/Gaziantep",
        "lat": "36.83585303235730",
        "lng": "37.99529390905530",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1546",
        "town": "Nizip",
        "location": "Nizip/Gaziantep",
        "lat": "36.99890637344840",
        "lng": "37.80169580358430",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1974",
        "town": "Nurdağı",
        "location": "Nurdağı/Gaziantep",
        "lat": "37.17566671649601",
        "lng": "36.74073793064950",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1549",
        "town": "Oğuzeli",
        "location": "Oğuzeli/Gaziantep",
        "lat": "36.96516101378340",
        "lng": "37.50850961623520",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1841",
        "town": "Şahinbey",
        "location": "Şahinbey/Gaziantep",
        "lat": "37.08793961600211",
        "lng": "37.35252953954790",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "27",
        "city": "Gaziantep",
        "townId": "1720",
        "town": "Yavuzeli",
        "location": "Yavuzeli/Gaziantep",
        "lat": "37.31639781025190",
        "lng": "37.56327811561730",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1352",
        "town": "Merkez",
        "location": "Merkez/Giresun",
        "lat": "40,9166768986075",
        "lng": "38,3817387403997",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1133",
        "town": "Alucra",
        "location": "Alucra/Giresun",
        "lat": "40.32603745939840",
        "lng": "38.77132354356960",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1212",
        "town": "Bulancak",
        "location": "Bulancak/Giresun",
        "lat": "40.93992290559931",
        "lng": "38.23172989180400",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1893",
        "town": "Çamoluk",
        "location": "Çamoluk/Giresun",
        "lat": "40.13351808425211",
        "lng": "38.74547047958050",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1894",
        "town": "Çanakçı",
        "location": "Çanakçı/Giresun",
        "lat": "40.91771393689941",
        "lng": "39.00999500171590",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1272",
        "town": "Dereli",
        "location": "Dereli/Giresun",
        "lat": "40.74047771248460",
        "lng": "38.44990968111570",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1912",
        "town": "Doğankent",
        "location": "Doğankent/Giresun",
        "lat": "40.80995110271630",
        "lng": "38.91468403728620",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1320",
        "town": "Espiye",
        "location": "Espiye/Giresun",
        "lat": "40.94978081562650",
        "lng": "38.70633076893890",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1324",
        "town": "Eynesil",
        "location": "Eynesil/Giresun",
        "lat": "41.06382146334260",
        "lng": "39.14009943275110",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1361",
        "town": "Görele",
        "location": "Görele/Giresun",
        "lat": "41.03731601320900",
        "lng": "38.99960184293020",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1930",
        "town": "Güce",
        "location": "Güce/Giresun",
        "lat": "40.90132244256710",
        "lng": "38.80868262385410",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1465",
        "town": "Keşap",
        "location": "Keşap/Giresun",
        "lat": "40.91718142596300",
        "lng": "38.51294036756420",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1837",
        "town": "Piraziz",
        "location": "Piraziz/Giresun",
        "lat": "40.95277149098210",
        "lng": "38.12867084112260",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1654",
        "town": "Şebinkarahisar",
        "location": "Şebinkarahisar/Giresun",
        "lat": "40.28875891932470",
        "lng": "38.42343950041830",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1678",
        "town": "Tirebolu",
        "location": "Tirebolu/Giresun",
        "lat": "41.00756026994911",
        "lng": "38.81453087224130",
        "region": "Karadeniz"
    },
    {
        "cityId": "28",
        "city": "Giresun",
        "townId": "1854",
        "town": "Yağlıdere",
        "location": "Yağlıdere/Giresun",
        "lat": "40.86289370752210",
        "lng": "38.62266916513960",
        "region": "Karadeniz"
    },
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1369",
        "town": "Merkez",
        "location": "Merkez/Gümüşhane",
        "lat": "40,4603131325281",
        "lng": "39,473043622008",
        "region": "Karadeniz"
    },
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1458",
        "town": "Kelkit",
        "location": "Kelkit/Gümüşhane",
        "lat": "40.14277012934700",
        "lng": "39.43331616121400",
        "region": "Karadeniz"
    },
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1822",
        "town": "Köse",
        "location": "Köse/Gümüşhane",
        "lat": "40.21380471050881",
        "lng": "39.65997353776770",
        "region": "Karadeniz"
    },
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1971",
        "town": "Kürtün",
        "location": "Kürtün/Gümüşhane",
        "lat": "40.70183477464311",
        "lng": "39.08571007567190",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1660",
        "town": "Şiran",
        "location": "Şiran/Gümüşhane",
        "lat": "40.17914803578190",
        "lng": "39.12272203289360",
        "region": "Karadeniz"
    },
    {
        "cityId": "29",
        "city": "Gümüşhane",
        "townId": "1684",
        "town": "Torul",
        "location": "Torul/Gümüşhane",
        "lat": "40.55467735982540",
        "lng": "39.29407626281840",
        "region": "Karadeniz"
    },
    {
        "cityId": "30",
        "city": "Hakkari",
        "townId": "1377",
        "town": "Merkez",
        "location": "Merkez/Hakkari",
        "lat": "37,557759827423",
        "lng": "43,7499252742894",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "30",
        "city": "Hakkari",
        "townId": "1261",
        "town": "Çukurca",
        "location": "Çukurca/Hakkari",
        "lat": "37.24576725190290",
        "lng": "43.60693118728250",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "30",
        "city": "Hakkari",
        "townId": "2107",
        "town": "Derecik",
        "location": "Derecik/Hakkari",
        "lat": "37.08229529861800",
        "lng": "44.31085139815310",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "30",
        "city": "Hakkari",
        "townId": "1656",
        "town": "Şemdinli",
        "location": "Şemdinli/Hakkari",
        "lat": "37.30878976834930",
        "lng": "44.57043541268020",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "30",
        "city": "Hakkari",
        "townId": "1737",
        "town": "Yüksekova",
        "location": "Yüksekova/Hakkari",
        "lat": "37.57303570930480",
        "lng": "44.28071414602310",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "2080",
        "town": "Antakya",
        "location": "Antakya/Hatay (Merkez)",
        "lat": "36.2259899039988",
        "lng": "36.1323939077353",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1131",
        "town": "Altınözü",
        "location": "Altınözü/Hatay",
        "lat": "36.11129025226700",
        "lng": "36.24823384428710",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "2081",
        "town": "Arsuz",
        "location": "Arsuz/Hatay",
        "lat": "36.42253804819741",
        "lng": "35.90680795387340",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1887",
        "town": "Belen",
        "location": "Belen/Hatay",
        "lat": "36.49116622020640",
        "lng": "36.19622576321570",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "2082",
        "town": "Defne",
        "location": "Defne/Hatay",
        "lat": "36.19534753677911",
        "lng": "36.14765595093740",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1289",
        "town": "Dörtyol",
        "location": "Dörtyol/Hatay",
        "lat": "36.82822479809210",
        "lng": "36.19626514835800",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1792",
        "town": "Erzin",
        "location": "Erzin/Hatay",
        "lat": "36.95587896013570",
        "lng": "36.19910368822331",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1382",
        "town": "Hassa",
        "location": "Hassa/Hatay",
        "lat": "36.79770535816950",
        "lng": "36.53339980829400",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1413",
        "town": "İskenderun",
        "location": "İskenderun/Hatay",
        "lat": "36.58474903394970",
        "lng": "36.17555666948131",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1468",
        "town": "Kırıkhan",
        "location": "Kırıkhan/Hatay",
        "lat": "36.50014060029460",
        "lng": "36.37307959466181",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1970",
        "town": "Kumlu",
        "location": "Kumlu/Hatay",
        "lat": "36.36446808063610",
        "lng": "36.45686292203540",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "2083",
        "town": "Payas",
        "location": "Payas/Hatay",
        "lat": "36.74751655023840",
        "lng": "36.21558977215480",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1585",
        "town": "Reyhanlı",
        "location": "Reyhanlı/Hatay",
        "lat": "36.28320955049520",
        "lng": "36.56722358869210",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1591",
        "town": "Samandağ",
        "location": "Samandağ/Hatay",
        "lat": "36.08722622779970",
        "lng": "36.00088814725251",
        "region": "Akdeniz"
    },
    {
        "cityId": "31",
        "city": "Hatay",
        "townId": "1721",
        "town": "Yayladağı",
        "location": "Yayladağı/Hatay",
        "lat": "35.90367203506660",
        "lng": "36.05016581999390",
        "region": "Akdeniz"
    },
    {
        "cityId": "76",
        "city": "Iğdır",
        "townId": "1398",
        "town": "Merkez",
        "location": "Merkez/Iğdır",
        "lat": "39,9194772145932",
        "lng": "44,0412751746557",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "76",
        "city": "Iğdır",
        "townId": "1142",
        "town": "Aralık",
        "location": "Aralık/Iğdır",
        "lat": "39.87614181971510",
        "lng": "44.51245462634121",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "76",
        "city": "Iğdır",
        "townId": "2011",
        "town": "Karakoyunlu",
        "location": "Karakoyunlu/Iğdır",
        "lat": "39.97522860375270",
        "lng": "44.17858758701550",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "76",
        "city": "Iğdır",
        "townId": "1692",
        "town": "Tuzluca",
        "location": "Tuzluca/Iğdır",
        "lat": "40.06482486339680",
        "lng": "43.66268540366741",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1401",
        "town": "Merkez",
        "location": "Merkez/Isparta",
        "lat": "37,7800303484637",
        "lng": "30,5657567689807",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1755",
        "town": "Aksu",
        "location": "Aksu/Isparta",
        "lat": "37.79943373378731",
        "lng": "31.06784604637140",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1154",
        "town": "Atabey",
        "location": "Atabey/Isparta",
        "lat": "37.95080180616740",
        "lng": "30.63152063893280",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1297",
        "town": "Eğirdir",
        "location": "Eğirdir/Isparta",
        "lat": "37.87458555216350",
        "lng": "30.82830928091120",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1341",
        "town": "Gelendost",
        "location": "Gelendost/Isparta",
        "lat": "38.11300232229340",
        "lng": "31.02436527114590",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1929",
        "town": "Gönen",
        "location": "Gönen/Isparta",
        "lat": "37.94973719309490",
        "lng": "30.50960872088000",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1456",
        "town": "Keçiborlu",
        "location": "Keçiborlu/Isparta",
        "lat": "37.94222852544620",
        "lng": "30.29654810344550",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1615",
        "town": "Senirkent",
        "location": "Senirkent/Isparta",
        "lat": "38.10848104921830",
        "lng": "30.55048876125340",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1648",
        "town": "Sütçüler",
        "location": "Sütçüler/Isparta",
        "lat": "37.49443856795420",
        "lng": "30.98164480755500",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1651",
        "town": "Şarkikaraağaç",
        "location": "Şarkikaraağaç/Isparta",
        "lat": "38.08625219321371",
        "lng": "31.37409989006280",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1699",
        "town": "Uluborlu",
        "location": "Uluborlu/Isparta",
        "lat": "38.07891937384460",
        "lng": "30.44838092076120",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "1717",
        "town": "Yalvaç",
        "location": "Yalvaç/Isparta",
        "lat": "38.30485217267100",
        "lng": "31.16317372502960",
        "region": "Akdeniz"
    },
    {
        "cityId": "32",
        "city": "Isparta",
        "townId": "2001",
        "town": "Yenişarbademli",
        "location": "Yenişarbademli/Isparta",
        "lat": "37.70707335505751",
        "lng": "31.38964731388170",
        "region": "Akdeniz"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1852",
        "town": "Ümraniye",
        "location": "Ümraniye/İstanbul (Anadolu Merkez)",
        "lat": "41,0292042108345",
        "lng": "29,1053096945595",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1103",
        "town": "Adalar",
        "location": "Adalar/İstanbul (Anadolu)",
        "lat": "40.87475709971890",
        "lng": "29.12828996012970",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2049",
        "town": "Ataşehir",
        "location": "Ataşehir/İstanbul (Anadolu)",
        "lat": "40.98833357782420",
        "lng": "29.12517317026840",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1185",
        "town": "Beykoz",
        "location": "Beykoz/İstanbul (Anadolu)",
        "lat": "41.12587488458071",
        "lng": "29.09799768737450",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2052",
        "town": "Çekmeköy",
        "location": "Çekmeköy/İstanbul (Anadolu)",
        "lat": "41.04111296915850",
        "lng": "29.23610525072250",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1421",
        "town": "Kadıköy",
        "location": "Kadıköy/İstanbul (Anadolu)",
        "lat": "40.99096223602460",
        "lng": "29.03565889920850",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1449",
        "town": "Kartal",
        "location": "Kartal/İstanbul (Anadolu)",
        "lat": "40.89277618073980",
        "lng": "29.19361326372860",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2012",
        "town": "Maltepe",
        "location": "Maltepe/İstanbul (Anadolu)",
        "lat": "40.94322935787170",
        "lng": "29.12983839206170",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1835",
        "town": "Pendik",
        "location": "Pendik/İstanbul (Anadolu)",
        "lat": "40.88849476383770",
        "lng": "29.23827233574370",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2054",
        "town": "Sancaktepe",
        "location": "Sancaktepe/İstanbul (Anadolu)",
        "lat": "41.01583653314300",
        "lng": "29.20488082790600",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2014",
        "town": "Sultanbeyli",
        "location": "Sultanbeyli/İstanbul (Anadolu)",
        "lat": "40.96904723815060",
        "lng": "29.25534756798640",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1659",
        "town": "Şile",
        "location": "Şile/İstanbul (Anadolu)",
        "lat": "41.15719263432031",
        "lng": "29.60914920282890",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "2015",
        "town": "Tuzla",
        "location": "Tuzla/İstanbul (Anadolu)",
        "lat": "40.84956036237210",
        "lng": "29.29808652974270",
        "region": "Marmara"
    },
    
    {
        "cityId": "34",
        "city": "İstanbul (Anadolu)",
        "townId": "1708",
        "town": "Üsküdar",
        "location": "Üsküdar/İstanbul (Anadolu)",
        "lat": "41.02274506301920",
        "lng": "29.04784966097980",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2050",
        "town": "Başakşehir",
        "location": "Başakşehir/İstanbul (Avrupa Merkez)",
        "lat": "41,1261979945482",
        "lng": "28,8068868223928",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2048",
        "town": "Arnavutköy",
        "location": "Arnavutköy/İstanbul (Avrupa)",
        "lat": "41.20460227958231",
        "lng": "28.72824332627700",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2003",
        "town": "Avcılar",
        "location": "Avcılar/İstanbul (Avrupa)",
        "lat": "40.98571899293691",
        "lng": "28.72238920075850",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2004",
        "town": "Bağcılar",
        "location": "Bağcılar/İstanbul (Avrupa)",
        "lat": "41.04559866881511",
        "lng": "28.81025262755800",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2005",
        "town": "Bahçelievler",
        "location": "Bahçelievler/İstanbul (Avrupa)",
        "lat": "40.99220391251081",
        "lng": "28.85094691541240",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1166",
        "town": "Bakırköy",
        "location": "Bakırköy/İstanbul (Avrupa)",
        "lat": "40.99042246435920",
        "lng": "28.85160146174040",
        "region": "Marmara"
    },
    
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1886",
        "town": "Bayrampaşa",
        "location": "Bayrampaşa/İstanbul (Avrupa)",
        "lat": "41.05010635917680",
        "lng": "28.91184371237980",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1183",
        "town": "Beşiktaş",
        "location": "Beşiktaş/İstanbul (Avrupa)",
        "lat": "41.03835223704111",
        "lng": "28.99587702742090",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2051",
        "town": "Beylikdüzü",
        "location": "Beylikdüzü/İstanbul (Avrupa)",
        "lat": "40.98950129196590",
        "lng": "28.66758764439360",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1186",
        "town": "Beyoğlu",
        "location": "Beyoğlu/İstanbul (Avrupa)",
        "lat": "41.03359865319640",
        "lng": "28.97446951347540",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1782",
        "town": "Büyükçekmece",
        "location": "Büyükçekmece/İstanbul (Avrupa)",
        "lat": "41.01798344712690",
        "lng": "28.56319446821280",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1237",
        "town": "Çatalca",
        "location": "Çatalca/İstanbul (Avrupa)",
        "lat": "41.13415986149591",
        "lng": "28.46656072750470",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2016",
        "town": "Esenler",
        "location": "Esenler/İstanbul (Avrupa)",
        "lat": "41.04553380789951",
        "lng": "28.88478103520910",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2053",
        "town": "Esenyurt",
        "location": "Esenyurt/İstanbul (Avrupa)",
        "lat": "41.01704309961320",
        "lng": "28.67924803687060",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1325",
        "town": "Eyüpsultan",
        "location": "Eyüpsultan/İstanbul (Avrupa)",
        "lat": "41.04586321037210",
        "lng": "28.93684243620170",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1327",
        "town": "Fatih",
        "location": "Fatih/İstanbul (Avrupa)",
        "lat": "41.02442958500901",
        "lng": "28.92945784282490",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1336",
        "town": "Gaziosmanpaşa",
        "location": "Gaziosmanpaşa/İstanbul (Avrupa)",
        "lat": "41.05812479275530",
        "lng": "28.91344586219450",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2010",
        "town": "Güngören",
        "location": "Güngören/İstanbul (Avrupa)",
        "lat": "41.01626063690880",
        "lng": "28.87920982706020",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1810",
        "town": "Kağıthane",
        "location": "Kağıthane/İstanbul (Avrupa)",
        "lat": "41.07923376442840",
        "lng": "28.97466284387140",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1823",
        "town": "Küçükçekmece",
        "location": "Küçükçekmece/İstanbul (Avrupa)",
        "lat": "40.99926932443300",
        "lng": "28.79689843219320",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1604",
        "town": "Sarıyer",
        "location": "Sarıyer/İstanbul (Avrupa)",
        "lat": "41.17242320350941",
        "lng": "29.05275794358950",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1622",
        "town": "Silivri",
        "location": "Silivri/İstanbul (Avrupa)",
        "lat": "41.07875415400290",
        "lng": "28.23952596019690",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "2055",
        "town": "Sultangazi",
        "location": "Sultangazi/İstanbul (Avrupa)",
        "lat": "41.10902703321220",
        "lng": "28.87801704823280",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1663",
        "town": "Şişli",
        "location": "Şişli/İstanbul (Avrupa)",
        "lat": "41.06379695364860",
        "lng": "28.98316438038040",
        "region": "Marmara"
    },
    {
        "cityId": "34",
        "city": "İstanbul (Avrupa)",
        "townId": "1739",
        "town": "Zeytinburnu",
        "location": "Zeytinburnu/İstanbul (Avrupa)",
        "lat": "40.99370812613320",
        "lng": "28.89471172901900",
        "region": "Marmara"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1780",
        "town": "Buca",
        "location": "Buca/İzmir (Merkez)",
        "lat": "38.4014457585833",
        "lng": "27.1470305645435",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1128",
        "town": "Aliağa",
        "location": "Aliağa/İzmir",
        "lat": "38.79571804170890",
        "lng": "26.97521169311400",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2006",
        "town": "Balçova",
        "location": "Balçova/İzmir",
        "lat": "38.39412282041800",
        "lng": "27.04486567510610",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1178",
        "town": "Bayındır",
        "location": "Bayındır/İzmir",
        "lat": "38.21341230414270",
        "lng": "27.64838189383120",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2056",
        "town": "Bayraklı",
        "location": "Bayraklı/İzmir",
        "lat": "38.46191935474910",
        "lng": "27.17135787949470",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1181",
        "town": "Bergama",
        "location": "Bergama/İzmir",
        "lat": "39.11296322253260",
        "lng": "27.18282542008850",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1776",
        "town": "Beydağ",
        "location": "Beydağ/İzmir",
        "lat": "38.09153682290920",
        "lng": "28.21152241719900",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1203",
        "town": "Bornova",
        "location": "Bornova/İzmir",
        "lat": "38.46206321557190",
        "lng": "27.22654626255810",
        "region": "Ege"
    },
    
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1251",
        "town": "Çeşme",
        "location": "Çeşme/İzmir",
        "lat": "38.31242204593230",
        "lng": "26.30449602478000",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2007",
        "town": "Çiğli",
        "location": "Çiğli/İzmir",
        "lat": "38.48193000197410",
        "lng": "27.06348671205060",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1280",
        "town": "Dikili",
        "location": "Dikili/İzmir",
        "lat": "39.08028075279250",
        "lng": "26.92234925501280",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1334",
        "town": "Foça",
        "location": "Foça/İzmir",
        "lat": "38.67053415476540",
        "lng": "26.75820017731190",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2009",
        "town": "Gaziemir",
        "location": "Gaziemir/İzmir",
        "lat": "38.31268419432450",
        "lng": "27.14231999086890",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2018",
        "town": "Güzelbahçe",
        "location": "Güzelbahçe/İzmir",
        "lat": "38.36469554222940",
        "lng": "26.87311517557810",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2057",
        "town": "Karabağlar",
        "location": "Karabağlar/İzmir",
        "lat": "38.39999200217880",
        "lng": "27.12742548003320",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1432",
        "town": "Karaburun",
        "location": "Karaburun/İzmir",
        "lat": "38.59661000602520",
        "lng": "26.54724550749710",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1448",
        "town": "Karşıyaka",
        "location": "Karşıyaka/İzmir",
        "lat": "38.46990201418091",
        "lng": "27.11155958106070",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1461",
        "town": "Kemalpaşa",
        "location": "Kemalpaşa/İzmir",
        "lat": "38.42175427974710",
        "lng": "27.43951193114870",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1467",
        "town": "Kınık",
        "location": "Kınık/İzmir",
        "lat": "39.10482858125510",
        "lng": "27.40480318856310",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1477",
        "town": "Kiraz",
        "location": "Kiraz/İzmir",
        "lat": "38.21888426712740",
        "lng": "28.20732704692070",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1819",
        "town": "Konak",
        "location": "Konak/İzmir",
        "lat": "38.42376706077780",
        "lng": "27.14283515976130",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1826",
        "town": "Menderes",
        "location": "Menderes/İzmir",
        "lat": "38.26224480650150",
        "lng": "27.12990413179010",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1521",
        "town": "Menemen",
        "location": "Menemen/İzmir",
        "lat": "38.60291364960950",
        "lng": "27.07828381392410",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "2013",
        "town": "Narlıdere",
        "location": "Narlıdere/İzmir",
        "lat": "38.39613578878930",
        "lng": "26.99710670002390",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1563",
        "town": "Ödemiş",
        "location": "Ödemiş/İzmir",
        "lat": "38.22313576148511",
        "lng": "27.95253292909770",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1611",
        "town": "Seferihisar",
        "location": "Seferihisar/İzmir",
        "lat": "38.21842888888840",
        "lng": "26.82703018740060",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1612",
        "town": "Selçuk",
        "location": "Selçuk/İzmir",
        "lat": "37.94800811385430",
        "lng": "27.36850616659560",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1677",
        "town": "Tire",
        "location": "Tire/İzmir",
        "lat": "38.10633672771500",
        "lng": "27.71300175911130",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1682",
        "town": "Torbalı",
        "location": "Torbalı/İzmir",
        "lat": "38.18399280404310",
        "lng": "27.35323073317360",
        "region": "Ege"
    },
    {
        "cityId": "35",
        "city": "İzmir",
        "townId": "1703",
        "town": "Urla",
        "location": "Urla/İzmir",
        "lat": "38.33536668351280",
        "lng": "26.76884709673540",
        "region": "Ege"
    },{
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "2085",
        "town": "Onikişubat",
        "location": "Onikişubat/Kahramanmaraş",
        "lat": "37,5683575385789",
        "lng": "36,9247930378887",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1107",
        "town": "Afşin",
        "location": "Afşin/Kahramanmaraş",
        "lat": "38.24373737121450",
        "lng": "36.91479556488230",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1136",
        "town": "Andırın",
        "location": "Andırın/Kahramanmaraş",
        "lat": "37.56942803246430",
        "lng": "36.35939062544330",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1785",
        "town": "Çağlayancerit",
        "location": "Çağlayancerit/Kahramanmaraş",
        "lat": "37.75034613999771",
        "lng": "37.29022118596751",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "2084",
        "town": "Dulkadiroğlu",
        "location": "Dulkadiroğlu/Kahramanmaraş",
        "lat": "37.56835753857890",
        "lng": "36.92479303788870",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1919",
        "town": "Ekinözü",
        "location": "Ekinözü/Kahramanmaraş",
        "lat": "38.06295733854420",
        "lng": "37.19643031484840",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1299",
        "town": "Elbistan",
        "location": "Elbistan/Kahramanmaraş",
        "lat": "38.20658253509700",
        "lng": "37.19304334649520",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1353",
        "town": "Göksun",
        "location": "Göksun/Kahramanmaraş",
        "lat": "38.02259337293730",
        "lng": "36.50378387800020",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1975",
        "town": "Nurhak",
        "location": "Nurhak/Kahramanmaraş",
        "lat": "37.96567975129981",
        "lng": "37.44594896089780",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1570",
        "town": "Pazarcık",
        "location": "Pazarcık/Kahramanmaraş",
        "lat": "37.48785777187310",
        "lng": "37.29038871468040",
        "region": "Akdeniz"
    },
    {
        "cityId": "46",
        "city": "Kahramanmaraş",
        "townId": "1694",
        "town": "Türkoğlu",
        "location": "Türkoğlu/Kahramanmaraş",
        "lat": "37.37705010209610",
        "lng": "36.85964413896621",
        "region": "Akdeniz"
    },
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1433",
        "town": "Merkez",
        "location": "Merkez/Karabük",
        "lat": "41,1943651289331",
        "lng": "32,6243379822934",
        "region": "Karadeniz"
    },
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1296",
        "town": "Eflani",
        "location": "Eflani/Karabük",
        "lat": "41.42287956377970",
        "lng": "32.95618099657690",
        "region": "Karadeniz"
    },
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1321",
        "town": "Eskipazar",
        "location": "Eskipazar/Karabük",
        "lat": "40.94766241726650",
        "lng": "32.53240672865990",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1561",
        "town": "Ovacık",
        "location": "Ovacık/Karabük",
        "lat": "41.07367695440940",
        "lng": "32.91385277065801",
        "region": "Karadeniz"
    },
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1587",
        "town": "Safranbolu",
        "location": "Safranbolu/Karabük",
        "lat": "41.24933871821960",
        "lng": "32.68314159372100",
        "region": "Karadeniz"
    },
    {
        "cityId": "78",
        "city": "Karabük",
        "townId": "1856",
        "town": "Yenice",
        "location": "Yenice/Karabük",
        "lat": "41.20197670547160",
        "lng": "32.32656909293761",
        "region": "Karadeniz"
    },
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1439",
        "town": "Merkez",
        "location": "Merkez/Karaman",
        "lat": "37,1833069101173",
        "lng": "33,1900386687291",
        "region": "İç Anadolu"
    },
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1768",
        "town": "Ayrancı",
        "location": "Ayrancı/Karaman",
        "lat": "37.36585519205250",
        "lng": "33.67916918316500",
        "region": "İç Anadolu"
    },
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1884",
        "town": "Başyayla",
        "location": "Başyayla/Karaman",
        "lat": "36.74587440078120",
        "lng": "32.69333894958550",
        "region": "İç Anadolu"
    },
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1316",
        "town": "Ermenek",
        "location": "Ermenek/Karaman",
        "lat": "36.64090049721851",
        "lng": "32.89405653692960",
        "region": "İç Anadolu"
    },
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1862",
        "town": "Kazımkarabekir",
        "location": "Kazımkarabekir/Karaman",
        "lat": "37.22965714992000",
        "lng": "32.96054806677671",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "70",
        "city": "Karaman",
        "townId": "1983",
        "town": "Sarıveliler",
        "location": "Sarıveliler/Karaman",
        "lat": "36.67265712857070",
        "lng": "32.62504697841690",
        "region": "İç Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1447",
        "town": "Merkez",
        "location": "Merkez/Kars",
        "lat": "40,5872755629814",
        "lng": "43,1275805512126",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1756",
        "town": "Akyaka",
        "location": "Akyaka/Kars",
        "lat": "40.74165506032690",
        "lng": "43.62070349940440",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1149",
        "town": "Arpaçay",
        "location": "Arpaçay/Kars",
        "lat": "40.84558268784160",
        "lng": "43.32030985367030",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1279",
        "town": "Digor",
        "location": "Digor/Kars",
        "lat": "40.37814863548100",
        "lng": "43.41884855805550",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1424",
        "town": "Kağızman",
        "location": "Kağızman/Kars",
        "lat": "40.15431803774240",
        "lng": "43.11441494413050",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1601",
        "town": "Sarıkamış",
        "location": "Sarıkamış/Kars",
        "lat": "40.30674315403220",
        "lng": "42.64947471832420",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1614",
        "town": "Selim",
        "location": "Selim/Kars",
        "lat": "40.46849755729211",
        "lng": "42.78474818160760",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "36",
        "city": "Kars",
        "townId": "1645",
        "town": "Susuz",
        "location": "Susuz/Kars",
        "lat": "40.77886934061750",
        "lng": "43.12920261042810",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1450",
        "town": "Merkez",
        "location": "Merkez/Kastamonu",
        "lat": "41,3920373821459",
        "lng": "33,7816745698901",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1101",
        "town": "Abana",
        "location": "Abana/Kastamonu",
        "lat": "41.97762205711810",
        "lng": "34.00534611628170",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1867",
        "town": "Ağlı",
        "location": "Ağlı/Kastamonu",
        "lat": "41.68882582150021",
        "lng": "33.55538332576900",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1140",
        "town": "Araç",
        "location": "Araç/Kastamonu",
        "lat": "41.24253635527171",
        "lng": "33.32801332114820",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1162",
        "town": "Azdavay",
        "location": "Azdavay/Kastamonu",
        "lat": "41.64186147876270",
        "lng": "33.30173482848450",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1208",
        "town": "Bozkurt",
        "location": "Bozkurt/Kastamonu",
        "lat": "41.95883751326620",
        "lng": "34.01253037546190",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1221",
        "town": "Cide",
        "location": "Cide/Kastamonu",
        "lat": "41.89805050983710",
        "lng": "32.99880895579070",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1238",
        "town": "Çatalzeytin",
        "location": "Çatalzeytin/Kastamonu",
        "lat": "41.95284632519550",
        "lng": "34.22682667158520",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1264",
        "town": "Daday",
        "location": "Daday/Kastamonu",
        "lat": "41.47673131909830",
        "lng": "33.46425938295930",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1277",
        "town": "Devrekani",
        "location": "Devrekani/Kastamonu",
        "lat": "41.60597944357460",
        "lng": "33.83824069930460",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1915",
        "town": "Doğanyurt",
        "location": "Doğanyurt/Kastamonu",
        "lat": "42.00428948805461",
        "lng": "33.46036105095331",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1940",
        "town": "Hanönü",
        "location": "Hanönü/Kastamonu",
        "lat": "41.62426950200291",
        "lng": "34.46729567871240",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1805",
        "town": "İhsangazi",
        "location": "İhsangazi/Kastamonu",
        "lat": "41.20397660494120",
        "lng": "33.55483887300470",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1410",
        "town": "İnebolu",
        "location": "İnebolu/Kastamonu",
        "lat": "41.97929472672461",
        "lng": "33.75960490064840",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1499",
        "town": "Küre",
        "location": "Küre/Kastamonu",
        "lat": "41.81070353681880",
        "lng": "33.71307624969460",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1836",
        "town": "Pınarbaşı",
        "location": "Pınarbaşı/Kastamonu",
        "lat": "41.60382086646730",
        "lng": "33.11070786084210",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1984",
        "town": "Seydiler",
        "location": "Seydiler/Kastamonu",
        "lat": "41.61580708457720",
        "lng": "33.72539779458250",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1845",
        "town": "Şenpazar",
        "location": "Şenpazar/Kastamonu",
        "lat": "41.80824274737230",
        "lng": "33.23370621714940",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1666",
        "town": "Taşköprü",
        "location": "Taşköprü/Kastamonu",
        "lat": "41.51290692255350",
        "lng": "34.21127412988080",
        "region": "Karadeniz"
    },
    {
        "cityId": "37",
        "city": "Kastamonu",
        "townId": "1685",
        "town": "Tosya",
        "location": "Tosya/Kastamonu",
        "lat": "41.01249760942440",
        "lng": "34.04320507485010",
        "region": "Karadeniz"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1863",
        "town": "Kocasinan",
        "location": "Kocasinan/Kayseri (Merkez)",
        "lat": "38.7306906707495",
        "lng": "35.4826819762666",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1752",
        "town": "Akkışla",
        "location": "Akkışla/Kayseri",
        "lat": "39.00347117608270",
        "lng": "36.16786507823231",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1218",
        "town": "Bünyan",
        "location": "Bünyan/Kayseri",
        "lat": "38.85511621629270",
        "lng": "35.85213811318340",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1275",
        "town": "Develi",
        "location": "Develi/Kayseri",
        "lat": "38.40907841085240",
        "lng": "35.49091222117030",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1330",
        "town": "Felahiye",
        "location": "Felahiye/Kayseri",
        "lat": "39.09053136211520",
        "lng": "35.56951258279561",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1936",
        "town": "Hacılar",
        "location": "Hacılar/Kayseri",
        "lat": "38.64590415594590",
        "lng": "35.45256998856631",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1409",
        "town": "İncesu",
        "location": "İncesu/Kayseri",
        "lat": "38.62568760357450",
        "lng": "35.19083644728580",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1864",
        "town": "Melikgazi",
        "location": "Melikgazi/Kayseri",
        "lat": "38.72265052166230",
        "lng": "35.48699602587400",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1978",
        "town": "Özvatan",
        "location": "Özvatan/Kayseri",
        "lat": "39.10595096307260",
        "lng": "35.69926985806170",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1576",
        "town": "Pınarbaşı",
        "location": "Pınarbaşı/Kayseri",
        "lat": "38.72303210421420",
        "lng": "36.38976217545420",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1603",
        "town": "Sarıoğlan",
        "location": "Sarıoğlan/Kayseri",
        "lat": "39.07201241215450",
        "lng": "35.98200318048061",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1605",
        "town": "Sarız",
        "location": "Sarız/Kayseri",
        "lat": "38.48279906464650",
        "lng": "36.48684565281390",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1846",
        "town": "Talas",
        "location": "Talas/Kayseri",
        "lat": "38.69609393414440",
        "lng": "35.53832360604050",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1680",
        "town": "Tomarza",
        "location": "Tomarza/Kayseri",
        "lat": "38.44804536931960",
        "lng": "35.79901818999210",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1715",
        "town": "Yahyalı",
        "location": "Yahyalı/Kayseri",
        "lat": "38.13483836334381",
        "lng": "35.36365678342570",
        "region": "İç Anadolu"
    },
    {
        "cityId": "38",
        "city": "Kayseri",
        "townId": "1727",
        "town": "Yeşilhisar",
        "location": "Yeşilhisar/Kayseri",
        "lat": "38.33981191269470",
        "lng": "35.09015849108520",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1469",
        "town": "Merkez",
        "location": "Merkez/Kırıkkale",
        "lat": "39,839893551382",
        "lng": "33,5220650009509",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1880",
        "town": "Bahşili",
        "location": "Bahşili/Kırıkkale",
        "lat": "39.81793130420200",
        "lng": "33.47320075377620",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1882",
        "town": "Balışeyh",
        "location": "Balışeyh/Kırıkkale",
        "lat": "39.90975977856580",
        "lng": "33.71822890050270",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1901",
        "town": "Çelebi",
        "location": "Çelebi/Kırıkkale",
        "lat": "39.46467559670750",
        "lng": "33.52548797262780",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1268",
        "town": "Delice",
        "location": "Delice/Kırıkkale",
        "lat": "39.94355403101490",
        "lng": "34.03264966007600",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1954",
        "town": "Karakeçili",
        "location": "Karakeçili/Kırıkkale",
        "lat": "39.58033895006681",
        "lng": "33.38099843616250",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1463",
        "town": "Keskin",
        "location": "Keskin/Kırıkkale",
        "lat": "39.67181707068320",
        "lng": "33.61005328864320",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1638",
        "town": "Sulakyurt",
        "location": "Sulakyurt/Kırıkkale",
        "lat": "40.15847573807150",
        "lng": "33.71782474749120",
        "region": "İç Anadolu"
    },
    {
        "cityId": "71",
        "city": "Kırıkkale",
        "townId": "1992",
        "town": "Yahşihan",
        "location": "Yahşihan/Kırıkkale",
        "lat": "39.85809866071700",
        "lng": "33.45246312412440",
        "region": "İç Anadolu"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1471",
        "town": "Merkez",
        "location": "Merkez/Kırklareli",
        "lat": "41,7245998714177",
        "lng": "27,2178889415665",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1163",
        "town": "Babaeski",
        "location": "Babaeski/Kırklareli",
        "lat": "41.43027770328380",
        "lng": "27.09173456652370",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1270",
        "town": "Demirköy",
        "location": "Demirköy/Kırklareli",
        "lat": "41.82470122085770",
        "lng": "27.76565463227040",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1480",
        "town": "Kofçaz",
        "location": "Kofçaz/Kırklareli",
        "lat": "41.94038897631550",
        "lng": "27.15700504647710",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1505",
        "town": "Lüleburgaz",
        "location": "Lüleburgaz/Kırklareli",
        "lat": "41.40262642645760",
        "lng": "27.36589755876720",
        "region": "Marmara"
    },
    
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1572",
        "town": "Pehlivanköy",
        "location": "Pehlivanköy/Kırklareli",
        "lat": "41.34879933299670",
        "lng": "26.92707241894480",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1577",
        "town": "Pınarhisar",
        "location": "Pınarhisar/Kırklareli",
        "lat": "41.62846913836400",
        "lng": "27.51115818614060",
        "region": "Marmara"
    },
    {
        "cityId": "39",
        "city": "Kırklareli",
        "townId": "1714",
        "town": "Vize",
        "location": "Vize/Kırklareli",
        "lat": "41.57309548943190",
        "lng": "27.76711604385600",
        "region": "Marmara"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1472",
        "town": "Merkez",
        "location": "Merkez/Kırşehir",
        "lat": "39,1507328417764",
        "lng": "34,1694144846209",
        "region": "İç Anadolu"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1869",
        "town": "Akçakent",
        "location": "Akçakent/Kırşehir",
        "lat": "39.62502089559210",
        "lng": "34.09623352742650",
        "region": "İç Anadolu"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1754",
        "town": "Akpınar",
        "location": "Akpınar/Kırşehir",
        "lat": "39.45255009716540",
        "lng": "33.95872715636470",
        "region": "İç Anadolu"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1890",
        "town": "Boztepe",
        "location": "Boztepe/Kırşehir",
        "lat": "39.26403464697160",
        "lng": "34.26214997493050",
        "region": "İç Anadolu"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1254",
        "town": "Çiçekdağı",
        "location": "Çiçekdağı/Kırşehir",
        "lat": "39.60166792572930",
        "lng": "34.41813646421371",
        "region": "İç Anadolu"
    },
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1429",
        "town": "Kaman",
        "location": "Kaman/Kırşehir",
        "lat": "39.37316793380670",
        "lng": "33.72961661189200",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "40",
        "city": "Kırşehir",
        "townId": "1529",
        "town": "Mucur",
        "location": "Mucur/Kırşehir",
        "lat": "39.06685013740340",
        "lng": "34.37307196928800",
        "region": "İç Anadolu"
    },
    {
        "cityId": "79",
        "city": "Kilis",
        "townId": "1476",
        "town": "Merkez",
        "location": "Merkez/Kilis",
        "lat": "36,7083463818368",
        "lng": "37,1502796584144",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "79",
        "city": "Kilis",
        "townId": "2023",
        "town": "Elbeyli",
        "location": "Elbeyli/Kilis",
        "lat": "36.67502504051761",
        "lng": "37.46694532602780",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "79",
        "city": "Kilis",
        "townId": "2024",
        "town": "Musabeyli",
        "location": "Musabeyli/Kilis",
        "lat": "36.88588787325690",
        "lng": "36.91598247749110",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "79",
        "city": "Kilis",
        "townId": "2025",
        "town": "Polateli",
        "location": "Polateli/Kilis",
        "lat": "36.84272703266660",
        "lng": "37.14338885781950",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2062",
        "town": "İzmit",
        "location": "İzmit/Kocaeli (Merkez)",
        "lat": "40.7623308756194",
        "lng": "29.9657748550861",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2058",
        "town": "Başiskele",
        "location": "Başiskele/Kocaeli",
        "lat": "40.71392559989730",
        "lng": "29.92821275963330",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2059",
        "town": "Çayırova",
        "location": "Çayırova/Kocaeli",
        "lat": "40.83393962949600",
        "lng": "29.39027457887770",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2060",
        "town": "Darıca",
        "location": "Darıca/Kocaeli",
        "lat": "40.78596130358410",
        "lng": "29.38585398026460",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2030",
        "town": "Derince",
        "location": "Derince/Kocaeli",
        "lat": "40.75603545790080",
        "lng": "29.83100961975330",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2061",
        "town": "Dilovası",
        "location": "Dilovası/Kocaeli",
        "lat": "40.78095535766140",
        "lng": "29.54227222158220",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "1338",
        "town": "Gebze",
        "location": "Gebze/Kocaeli",
        "lat": "40.79717837030700",
        "lng": "29.44010759709660",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "1355",
        "town": "Gölcük",
        "location": "Gölcük/Kocaeli",
        "lat": "40.71203207339270",
        "lng": "29.84026176736510",
        "region": "Marmara"
    },
    
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "1430",
        "town": "Kandıra",
        "location": "Kandıra/Kocaeli",
        "lat": "41.06451885622301",
        "lng": "30.15508586649550",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "1440",
        "town": "Karamürsel",
        "location": "Karamürsel/Kocaeli",
        "lat": "40.69124100685930",
        "lng": "29.61636857217570",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "2063",
        "town": "Kartepe",
        "location": "Kartepe/Kocaeli",
        "lat": "40.73711487392560",
        "lng": "30.01160734663680",
        "region": "Marmara"
    },
    {
        "cityId": "41",
        "city": "Kocaeli",
        "townId": "1821",
        "town": "Körfez",
        "location": "Körfez/Kocaeli",
        "lat": "40.76873386097180",
        "lng": "29.76838483914040",
        "region": "Marmara"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1827",
        "town": "Meram",
        "location": "Meram/Konya (Merkez)",
        "lat": "37.879874205531",
        "lng": "32.4523513776348",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1868",
        "town": "Ahırlı",
        "location": "Ahırlı/Konya",
        "lat": "37.23915022425720",
        "lng": "32.12076634797880",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1753",
        "town": "Akören",
        "location": "Akören/Konya",
        "lat": "37.45179479077420",
        "lng": "32.37081425160870",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1122",
        "town": "Akşehir",
        "location": "Akşehir/Konya",
        "lat": "38.35677459357600",
        "lng": "31.42097258037900",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1760",
        "town": "Altınekin",
        "location": "Altınekin/Konya",
        "lat": "38.30809804937330",
        "lng": "32.86879604813970",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1188",
        "town": "Beyşehir",
        "location": "Beyşehir/Konya",
        "lat": "37.69286256756290",
        "lng": "31.72530112997470",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1207",
        "town": "Bozkır",
        "location": "Bozkır/Konya",
        "lat": "37.18210916501660",
        "lng": "32.24475405109051",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1222",
        "town": "Cihanbeyli",
        "location": "Cihanbeyli/Konya",
        "lat": "38.65992033657551",
        "lng": "32.91837213813620",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1902",
        "town": "Çeltik",
        "location": "Çeltik/Konya",
        "lat": "39.02382542743890",
        "lng": "31.79040322673310",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1262",
        "town": "Çumra",
        "location": "Çumra/Konya",
        "lat": "37.56989612178890",
        "lng": "32.77627585522900",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1907",
        "town": "Derbent",
        "location": "Derbent/Konya",
        "lat": "38.02018230594971",
        "lng": "32.00886469217110",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1789",
        "town": "Derebucak",
        "location": "Derebucak/Konya",
        "lat": "37.38924315485050",
        "lng": "31.50151337196040",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1285",
        "town": "Doğanhisar",
        "location": "Doğanhisar/Konya",
        "lat": "38.14161546797010",
        "lng": "31.68779437636960",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1920",
        "town": "Emirgazi",
        "location": "Emirgazi/Konya",
        "lat": "37.89150068610270",
        "lng": "33.82742097709081",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1312",
        "town": "Ereğli",
        "location": "Ereğli/Konya",
        "lat": "37.52456848116780",
        "lng": "34.02852698324341",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1933",
        "town": "Güneysınır",
        "location": "Güneysınır/Konya",
        "lat": "37.27759942416230",
        "lng": "32.72298347385450",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1375",
        "town": "Hadim",
        "location": "Hadim/Konya",
        "lat": "36.98772006229330",
        "lng": "32.46388889940561",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1937",
        "town": "Halkapınar",
        "location": "Halkapınar/Konya",
        "lat": "37.44004481523310",
        "lng": "34.19023754190620",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1804",
        "town": "Hüyük",
        "location": "Hüyük/Konya",
        "lat": "37.95679796992930",
        "lng": "31.59431314661150",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1400",
        "town": "Ilgın",
        "location": "Ilgın/Konya",
        "lat": "38.28163329693070",
        "lng": "31.91106489487630",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1422",
        "town": "Kadınhanı",
        "location": "Kadınhanı/Konya",
        "lat": "38.23158378539330",
        "lng": "32.21799321265200",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1441",
        "town": "Karapınar",
        "location": "Karapınar/Konya",
        "lat": "37.71373545682961",
        "lng": "33.53089822649790",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1814",
        "town": "Karatay",
        "location": "Karatay/Konya",
        "lat": "37.86917919743260",
        "lng": "32.54821974746261",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1491",
        "town": "Kulu",
        "location": "Kulu/Konya",
        "lat": "39.08907334479760",
        "lng": "33.07135111875750",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1598",
        "town": "Sarayönü",
        "location": "Sarayönü/Konya",
        "lat": "38.24898095606960",
        "lng": "32.41090478746670",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1839",
        "town": "Selçuklu",
        "location": "Selçuklu/Konya",
        "lat": "37.89229457839231",
        "lng": "32.47716769137881",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1617",
        "town": "Seydişehir",
        "location": "Seydişehir/Konya",
        "lat": "37.44803707843960",
        "lng": "31.85967256301920",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1848",
        "town": "Taşkent",
        "location": "Taşkent/Konya",
        "lat": "36.92373839408690",
        "lng": "32.49320304167081",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1990",
        "town": "Tuzlukçu",
        "location": "Tuzlukçu/Konya",
        "lat": "38.48450591156950",
        "lng": "31.61854167984220",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1994",
        "town": "Yalıhüyük",
        "location": "Yalıhüyük/Konya",
        "lat": "37.30075552025040",
        "lng": "32.08529684686240",
        "region": "İç Anadolu"
    },
    {
        "cityId": "42",
        "city": "Konya",
        "townId": "1735",
        "town": "Yunak",
        "location": "Yunak/Konya",
        "lat": "38.81096294952460",
        "lng": "31.73799153634920",
        "region": "İç Anadolu"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1500",
        "town": "Merkez",
        "location": "Merkez/Kütahya",
        "lat": "39,431128202083",
        "lng": "29,995030535088",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1132",
        "town": "Altıntaş",
        "location": "Altıntaş/Kütahya",
        "lat": "39.05856102490360",
        "lng": "30.09879073357810",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1764",
        "town": "Aslanapa",
        "location": "Aslanapa/Kütahya",
        "lat": "39.21486166794530",
        "lng": "29.87007496045350",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1898",
        "town": "Çavdarhisar",
        "location": "Çavdarhisar/Kütahya",
        "lat": "39.18888096719780",
        "lng": "29.62083234958120",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1288",
        "town": "Domaniç",
        "location": "Domaniç/Kütahya",
        "lat": "39.79615123314980",
        "lng": "29.60838790790520",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1790",
        "town": "Dumlupınar",
        "location": "Dumlupınar/Kütahya",
        "lat": "38.84987289587540",
        "lng": "29.98153964206590",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1304",
        "town": "Emet",
        "location": "Emet/Kütahya",
        "lat": "39.33870054103960",
        "lng": "29.26780674894100",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1339",
        "town": "Gediz",
        "location": "Gediz/Kütahya",
        "lat": "38.98899485884720",
        "lng": "29.39921856270950",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1802",
        "town": "Hisarcık",
        "location": "Hisarcık/Kütahya",
        "lat": "39.26273446015830",
        "lng": "29.22727645549710",
        "region": "Ege"
    },
    
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1979",
        "town": "Pazarlar",
        "location": "Pazarlar/Kütahya",
        "lat": "39.00075536128430",
        "lng": "29.12848813936650",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1625",
        "town": "Simav",
        "location": "Simav/Kütahya",
        "lat": "39.09320729938830",
        "lng": "28.97927628011390",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1843",
        "town": "Şaphane",
        "location": "Şaphane/Kütahya",
        "lat": "39.00802372674630",
        "lng": "29.20783539188860",
        "region": "Ege"
    },
    {
        "cityId": "43",
        "city": "Kütahya",
        "townId": "1671",
        "town": "Tavşanlı",
        "location": "Tavşanlı/Kütahya",
        "lat": "39.53916019821060",
        "lng": "29.48970820855480",
        "region": "Ege"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1772",
        "town": "Battalgazi",
        "location": "Battalgazi/Malatya (Merkez)",
        "lat": "38.4115461609288",
        "lng": "38.3622612780317",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1114",
        "town": "Akçadağ",
        "location": "Akçadağ/Malatya",
        "lat": "38.34444139796841",
        "lng": "37.97983046957600",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1143",
        "town": "Arapgir",
        "location": "Arapgir/Malatya",
        "lat": "39.04148136352930",
        "lng": "38.49212358360770",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1148",
        "town": "Arguvan",
        "location": "Arguvan/Malatya",
        "lat": "38.78266221674010",
        "lng": "38.26474629725930",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1265",
        "town": "Darende",
        "location": "Darende/Malatya",
        "lat": "38.55992403993730",
        "lng": "37.48963485476380",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1286",
        "town": "Doğanşehir",
        "location": "Doğanşehir/Malatya",
        "lat": "38.09406356197920",
        "lng": "37.87676558778550",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1914",
        "town": "Doğanyol",
        "location": "Doğanyol/Malatya",
        "lat": "38.31089059003170",
        "lng": "39.03713360347100",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1390",
        "town": "Hekimhan",
        "location": "Hekimhan/Malatya",
        "lat": "38.81902306904160",
        "lng": "37.93103319995101",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1953",
        "town": "Kale",
        "location": "Kale/Malatya",
        "lat": "38.40138915107500",
        "lng": "38.74620833580930",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1969",
        "town": "Kuluncak",
        "location": "Kuluncak/Malatya",
        "lat": "38.88063871901740",
        "lng": "37.66963035644941",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1582",
        "town": "Pütürge",
        "location": "Pütürge/Malatya",
        "lat": "38.20574885090870",
        "lng": "38.88225355470840",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1995",
        "town": "Yazıhan",
        "location": "Yazıhan/Malatya",
        "lat": "38.59610595510870",
        "lng": "38.18908082798380",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "44",
        "city": "Malatya",
        "townId": "1729",
        "town": "Yeşilyurt",
        "location": "Yeşilyurt/Malatya",
        "lat": "38.30553133440270",
        "lng": "38.24504464054921",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "2087",
        "town": "Yunusemre",
        "location": "Yunusemre/Manisa (Merkez)",
        "lat": "38.6181761566434",
        "lng": "27.4194018153383",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1751",
        "town": "Ahmetli",
        "location": "Ahmetli/Manisa",
        "lat": "38.51373091697340",
        "lng": "27.93793734448620",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1118",
        "town": "Akhisar",
        "location": "Akhisar/Manisa",
        "lat": "38.92594906682970",
        "lng": "27.83444925417230",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1127",
        "town": "Alaşehir",
        "location": "Alaşehir/Manisa",
        "lat": "38.36262674458620",
        "lng": "28.52090572839240",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1269",
        "town": "Demirci",
        "location": "Demirci/Manisa",
        "lat": "39.03657241701510",
        "lng": "28.65748864573550",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1793",
        "town": "Gölmarmara",
        "location": "Gölmarmara/Manisa",
        "lat": "38.71198588791151",
        "lng": "27.92158250803810",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1362",
        "town": "Gördes",
        "location": "Gördes/Manisa",
        "lat": "38.93379968739010",
        "lng": "28.28843460403350",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1470",
        "town": "Kırkağaç",
        "location": "Kırkağaç/Manisa",
        "lat": "39.10691730862171",
        "lng": "27.68682744448480",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1965",
        "town": "Köprübaşı",
        "location": "Köprübaşı/Manisa",
        "lat": "38.74268510361280",
        "lng": "28.39601179035220",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1489",
        "town": "Kula",
        "location": "Kula/Manisa",
        "lat": "38.54028084083250",
        "lng": "28.64747580559950",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1590",
        "town": "Salihli",
        "location": "Salihli/Manisa",
        "lat": "38.48877695129890",
        "lng": "28.13585142541370",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1600",
        "town": "Sarıgöl",
        "location": "Sarıgöl/Manisa",
        "lat": "38.24828817472290",
        "lng": "28.67058763333750",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1606",
        "town": "Saruhanlı",
        "location": "Saruhanlı/Manisa",
        "lat": "38.73047110497230",
        "lng": "27.58153074575360",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1613",
        "town": "Selendi",
        "location": "Selendi/Manisa",
        "lat": "38.74345103620150",
        "lng": "28.87019679716080",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1634",
        "town": "Soma",
        "location": "Soma/Manisa",
        "lat": "39.18520290422830",
        "lng": "27.60887637198310",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "2086",
        "town": "Şehzadeler",
        "location": "Şehzadeler/Manisa",
        "lat": "38.61817615664340",
        "lng": "27.41940181533830",
        "region": "Ege"
    },
    {
        "cityId": "45",
        "city": "Manisa",
        "townId": "1689",
        "town": "Turgutlu",
        "location": "Turgutlu/Manisa",
        "lat": "38.48975794652820",
        "lng": "27.70152712272270",
        "region": "Ege"
    },
    
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "2088",
        "town": "Artuklu",
        "location": "Artuklu/Mardin (Merkez)",
        "lat": "37.3252612934893",
        "lng": "40.7170709063669",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1787",
        "town": "Dargeçit",
        "location": "Dargeçit/Mardin",
        "lat": "37.55206819060620",
        "lng": "41.70086479487390",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1273",
        "town": "Derik",
        "location": "Derik/Mardin",
        "lat": "37.36077225844240",
        "lng": "40.26442529510810",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1474",
        "town": "Kızıltepe",
        "location": "Kızıltepe/Mardin",
        "lat": "37.18887171886430",
        "lng": "40.57603751666890",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1519",
        "town": "Mazıdağı",
        "location": "Mazıdağı/Mardin",
        "lat": "37.48151727098950",
        "lng": "40.49444070849770",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1526",
        "town": "Midyat",
        "location": "Midyat/Mardin",
        "lat": "37.42248885096371",
        "lng": "41.34648043599770",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1547",
        "town": "Nusaybin",
        "location": "Nusaybin/Mardin",
        "lat": "37.09057118350040",
        "lng": "41.21231530400150",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1564",
        "town": "Ömerli",
        "location": "Ömerli/Mardin",
        "lat": "37.40266598934790",
        "lng": "40.95439591139440",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "1609",
        "town": "Savur",
        "location": "Savur/Mardin",
        "lat": "37.54802283332660",
        "lng": "40.89399603261460",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "47",
        "city": "Mardin",
        "townId": "2002",
        "town": "Yeşilli",
        "location": "Yeşilli/Mardin",
        "lat": "37.33907880086750",
        "lng": "40.82014382251460",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "2064",
        "town": "Akdeniz",
        "location": "Akdeniz/Mersin (Merkez)",
        "lat": "36.8102964302223",
        "lng": "34.6204127705865",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1135",
        "town": "Anamur",
        "location": "Anamur/Mersin",
        "lat": "36.07217697115730",
        "lng": "32.83561929913880",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1766",
        "town": "Aydıncık",
        "location": "Aydıncık/Mersin",
        "lat": "36.14628002069190",
        "lng": "33.32463032494070",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1779",
        "town": "Bozyazı",
        "location": "Bozyazı/Mersin",
        "lat": "36.10558845574160",
        "lng": "32.97413268411951",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1892",
        "town": "Çamlıyayla",
        "location": "Çamlıyayla/Mersin",
        "lat": "37.16663222262830",
        "lng": "34.59345289562701",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1311",
        "town": "Erdemli",
        "location": "Erdemli/Mersin",
        "lat": "36.60574056455530",
        "lng": "34.31026902324740",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1366",
        "town": "Gülnar",
        "location": "Gülnar/Mersin",
        "lat": "36.33916541394370",
        "lng": "33.39750983733470",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "2065",
        "town": "Mezitli",
        "location": "Mezitli/Mersin",
        "lat": "36.76012025543350",
        "lng": "34.53497966195140",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1536",
        "town": "Mut",
        "location": "Mut/Mersin",
        "lat": "36.64202026480230",
        "lng": "33.44065426648450",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1621",
        "town": "Silifke",
        "location": "Silifke/Mersin",
        "lat": "36.37544094426590",
        "lng": "33.93730550303040",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "1665",
        "town": "Tarsus",
        "location": "Tarsus/Mersin",
        "lat": "36.94398880514150",
        "lng": "34.86115186782520",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "2066",
        "town": "Toroslar",
        "location": "Toroslar/Mersin",
        "lat": "36.85784173316440",
        "lng": "34.58567843597970",
        "region": "Akdeniz"
    },
    {
        "cityId": "33",
        "city": "Mersin",
        "townId": "2067",
        "town": "Yenişehir",
        "location": "Yenişehir/Mersin",
        "lat": "36.78585950465331",
        "lng": "34.56518614405390",
        "region": "Akdeniz"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "2089",
        "town": "Menteşe",
        "location": "Menteşe/Muğla (Merkez)",
        "lat": "37.2043847103318",
        "lng": "28.3674579176328",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1197",
        "town": "Bodrum",
        "location": "Bodrum/Muğla",
        "lat": "37.04980524666580",
        "lng": "27.44678434271270",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1742",
        "town": "Dalaman",
        "location": "Dalaman/Muğla",
        "lat": "36.81125545626780",
        "lng": "28.81149723643650",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1266",
        "town": "Datça",
        "location": "Datça/Muğla",
        "lat": "36.73946565144460",
        "lng": "27.67169671851060",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1331",
        "town": "Fethiye",
        "location": "Fethiye/Muğla",
        "lat": "36.66232012124640",
        "lng": "29.14744255827370",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1958",
        "town": "Kavaklıdere",
        "location": "Kavaklıdere/Muğla",
        "lat": "37.44615868968500",
        "lng": "28.36088311621700",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1488",
        "town": "Köyceğiz",
        "location": "Köyceğiz/Muğla",
        "lat": "36.97573325057700",
        "lng": "28.68697832465120",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1517",
        "town": "Marmaris",
        "location": "Marmaris/Muğla",
        "lat": "36.86002484413840",
        "lng": "28.27059029111180",
        "region": "Ege"
    },
    
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1528",
        "town": "Milas",
        "location": "Milas/Muğla",
        "lat": "37.28856179765260",
        "lng": "27.78154637168390",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1831",
        "town": "Ortaca",
        "location": "Ortaca/Muğla",
        "lat": "36.83441381782430",
        "lng": "28.77451975145250",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "2090",
        "town": "Seydikemer",
        "location": "Seydikemer/Muğla",
        "lat": "36.63617648937090",
        "lng": "29.36813647638310",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1695",
        "town": "Ula",
        "location": "Ula/Muğla",
        "lat": "37.11913636958050",
        "lng": "28.38270622619610",
        "region": "Ege"
    },
    {
        "cityId": "48",
        "city": "Muğla",
        "townId": "1719",
        "town": "Yatağan",
        "location": "Yatağan/Muğla",
        "lat": "37.34460852668400",
        "lng": "28.15677168281330",
        "region": "Ege"
    },
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1534",
        "town": "Merkez",
        "location": "Merkez/Muş",
        "lat": "38,7493405847425",
        "lng": "41,5037209488947",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1213",
        "town": "Bulanık",
        "location": "Bulanık/Muş",
        "lat": "39.09764732469900",
        "lng": "42.27089695837811",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1801",
        "town": "Hasköy",
        "location": "Hasköy/Muş",
        "lat": "38.68885666422800",
        "lng": "41.69516048512610",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1964",
        "town": "Korkut",
        "location": "Korkut/Muş",
        "lat": "38.73548973835210",
        "lng": "41.77925792837990",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1510",
        "town": "Malazgirt",
        "location": "Malazgirt/Muş",
        "lat": "39.14994579020240",
        "lng": "42.54363602205780",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "49",
        "city": "Muş",
        "townId": "1711",
        "town": "Varto",
        "location": "Varto/Muş",
        "lat": "39.16323761228600",
        "lng": "41.45462195675640",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1543",
        "town": "Merkez",
        "location": "Merkez/Nevşehir",
        "lat": "38,6360356248",
        "lng": "34,7058406456338",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1749",
        "town": "Acıgöl",
        "location": "Acıgöl/Nevşehir",
        "lat": "38.54942907391360",
        "lng": "34.50407846667521",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1155",
        "town": "Avanos",
        "location": "Avanos/Nevşehir",
        "lat": "38.70380873569970",
        "lng": "34.84257895695090",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1274",
        "town": "Derinkuyu",
        "location": "Derinkuyu/Nevşehir",
        "lat": "38.38175376496900",
        "lng": "34.74899566938700",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1367",
        "town": "Gülşehir",
        "location": "Gülşehir/Nevşehir",
        "lat": "38.74372494737730",
        "lng": "34.63366396547230",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1374",
        "town": "Hacıbektaş",
        "location": "Hacıbektaş/Nevşehir",
        "lat": "38.94698122807200",
        "lng": "34.57324201871340",
        "region": "İç Anadolu"
    },
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1485",
        "town": "Kozaklı",
        "location": "Kozaklı/Nevşehir",
        "lat": "39.21281501917530",
        "lng": "34.85308721706150",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "50",
        "city": "Nevşehir",
        "townId": "1707",
        "town": "Ürgüp",
        "location": "Ürgüp/Nevşehir",
        "lat": "38.64566736779380",
        "lng": "34.91069181274041",
        "region": "İç Anadolu"
    },
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1544",
        "town": "Merkez",
        "location": "Merkez/Niğde",
        "lat": "37,9659264127738",
        "lng": "34,7040257648782",
        "region": "İç Anadolu"
    },
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1876",
        "town": "Altunhisar",
        "location": "Altunhisar/Niğde",
        "lat": "38.00151160519300",
        "lng": "34.36206124869770",
        "region": "İç Anadolu"
    },
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1201",
        "town": "Bor",
        "location": "Bor/Niğde",
        "lat": "37.90699241964620",
        "lng": "34.56429705971140",
        "region": "İç Anadolu"
    },
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1225",
        "town": "Çamardı",
        "location": "Çamardı/Niğde",
        "lat": "37.83843346937070",
        "lng": "35.00200465393310",
        "region": "İç Anadolu"
    },
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1904",
        "town": "Çiftlik",
        "location": "Çiftlik/Niğde",
        "lat": "38.17477646351550",
        "lng": "34.48951294185410",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "51",
        "city": "Niğde",
        "townId": "1700",
        "town": "Ulukışla",
        "location": "Ulukışla/Niğde",
        "lat": "37.54597988287020",
        "lng": "34.48155165555840",
        "region": "İç Anadolu"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "2103",
        "town": "Altınordu",
        "location": "Altınordu/Ordu (Merkez)",
        "lat": "40.9862989505702",
        "lng": "37.8795667145771",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1119",
        "town": "Akkuş",
        "location": "Akkuş/Ordu",
        "lat": "40.79235326912680",
        "lng": "37.01812356124710",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1158",
        "town": "Aybastı",
        "location": "Aybastı/Ordu",
        "lat": "40.68533936938440",
        "lng": "37.39942836668120",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1891",
        "town": "Çamaş",
        "location": "Çamaş/Ordu",
        "lat": "40.90277619187411",
        "lng": "37.52802959933800",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1897",
        "town": "Çatalpınar",
        "location": "Çatalpınar/Ordu",
        "lat": "40.87721646837730",
        "lng": "37.44985447001271",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1900",
        "town": "Çaybaşı",
        "location": "Çaybaşı/Ordu",
        "lat": "41.01743390654450",
        "lng": "37.09925863383520",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1328",
        "town": "Fatsa",
        "location": "Fatsa/Ordu",
        "lat": "41.03167116360440",
        "lng": "37.50038612218821",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1358",
        "town": "Gölköy",
        "location": "Gölköy/Ordu",
        "lat": "40.69204467279100",
        "lng": "37.62202502194450",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1795",
        "town": "Gülyalı",
        "location": "Gülyalı/Ordu",
        "lat": "40.96710325103691",
        "lng": "38.05634244248330",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1797",
        "town": "Gürgentepe",
        "location": "Gürgentepe/Ordu",
        "lat": "40.78870712492261",
        "lng": "37.60075058165841",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1947",
        "town": "İkizce",
        "location": "İkizce/Ordu",
        "lat": "41.05316714168341",
        "lng": "37.07769675731631",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1950",
        "town": "Kabadüz",
        "location": "Kabadüz/Ordu",
        "lat": "40.86040175233240",
        "lng": "37.89119546161110",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1951",
        "town": "Kabataş",
        "location": "Kabataş/Ordu",
        "lat": "40.75355340919431",
        "lng": "37.44988894771950",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1482",
        "town": "Korgan",
        "location": "Korgan/Ordu",
        "lat": "40.82911730763360",
        "lng": "37.34444910403711",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1493",
        "town": "Kumru",
        "location": "Kumru/Ordu",
        "lat": "40.87722305391760",
        "lng": "37.26825674299050",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1525",
        "town": "Mesudiye",
        "location": "Mesudiye/Ordu",
        "lat": "40.46077565299210",
        "lng": "37.77124493095431",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1573",
        "town": "Perşembe",
        "location": "Perşembe/Ordu",
        "lat": "41.06696941747731",
        "lng": "37.77363413319520",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1696",
        "town": "Ulubey",
        "location": "Ulubey/Ordu",
        "lat": "40.87308875933360",
        "lng": "37.75854680219510",
        "region": "Karadeniz"
    },
    {
        "cityId": "52",
        "city": "Ordu",
        "townId": "1706",
        "town": "Ünye",
        "location": "Ünye/Ordu",
        "lat": "41.11383825108210",
        "lng": "37.26137976531260",
        "region": "Karadeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "1560",
        "town": "Merkez",
        "location": "Merkez/Osmaniye",
        "lat": "37,0746350086228",
        "lng": "36,2463474145806",
        "region": "Akdeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "1165",
        "town": "Bahçe",
        "location": "Bahçe/Osmaniye",
        "lat": "37.19403923402120",
        "lng": "36.57405777880990",
        "region": "Akdeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "1743",
        "town": "Düziçi",
        "location": "Düziçi/Osmaniye",
        "lat": "37.22712196450980",
        "lng": "36.44246674640420",
        "region": "Akdeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "2027",
        "town": "Hasanbeyli",
        "location": "Hasanbeyli/Osmaniye",
        "lat": "37.13133932031820",
        "lng": "36.55487204254441",
        "region": "Akdeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "1423",
        "town": "Kadirli",
        "location": "Kadirli/Osmaniye",
        "lat": "37.34718338078040",
        "lng": "36.07736064098950",
        "region": "Akdeniz"
    },
    
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "2028",
        "town": "Sumbas",
        "location": "Sumbas/Osmaniye",
        "lat": "37.44576372547900",
        "lng": "36.02952442505220",
        "region": "Akdeniz"
    },
    {
        "cityId": "80",
        "city": "Osmaniye",
        "townId": "2029",
        "town": "Toprakkale",
        "location": "Toprakkale/Osmaniye",
        "lat": "37.06578471130431",
        "lng": "36.14809359099170",
        "region": "Akdeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1586",
        "town": "Merkez",
        "location": "Merkez/Rize",
        "lat": "41,0268910263503",
        "lng": "40,5198895814259",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1146",
        "town": "Ardeşen",
        "location": "Ardeşen/Rize",
        "lat": "41.19455248476990",
        "lng": "40.98338699435370",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1228",
        "town": "Çamlıhemşin",
        "location": "Çamlıhemşin/Rize",
        "lat": "41.04906605365310",
        "lng": "41.00339383107660",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1241",
        "town": "Çayeli",
        "location": "Çayeli/Rize",
        "lat": "41.08398538862631",
        "lng": "40.71345213178791",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1908",
        "town": "Derepazarı",
        "location": "Derepazarı/Rize",
        "lat": "41.02480042920240",
        "lng": "40.42154688471050",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1332",
        "town": "Fındıklı",
        "location": "Fındıklı/Rize",
        "lat": "41.27307240120691",
        "lng": "41.14277904869110",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1796",
        "town": "Güneysu",
        "location": "Güneysu/Rize",
        "lat": "40.99938024458250",
        "lng": "40.59306259239100",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1943",
        "town": "Hemşin",
        "location": "Hemşin/Rize",
        "lat": "41.05163639257551",
        "lng": "40.89801931080730",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1405",
        "town": "İkizdere",
        "location": "İkizdere/Rize",
        "lat": "40.77772129533930",
        "lng": "40.56047561997100",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1949",
        "town": "İyidere",
        "location": "İyidere/Rize",
        "lat": "41.01100284553790",
        "lng": "40.35885102353280",
        "region": "Karadeniz"
    },
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1428",
        "town": "Kalkandere",
        "location": "Kalkandere/Rize",
        "lat": "40.92873564200500",
        "lng": "40.44234124560700",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "53",
        "city": "Rize",
        "townId": "1569",
        "town": "Pazar",
        "location": "Pazar/Rize",
        "lat": "41.18331034749950",
        "lng": "40.89442062405760",
        "region": "Karadeniz"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "2068",
        "town": "Adapazarı",
        "location": "Adapazarı/Sakarya (Merkez)",
        "lat": "40.7354867180519",
        "lng": "30.3834367177014",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1123",
        "town": "Akyazı",
        "location": "Akyazı/Sakarya",
        "lat": "40.67471194262330",
        "lng": "30.58668119533240",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "2069",
        "town": "Arifiye",
        "location": "Arifiye/Sakarya",
        "lat": "40.73527720752820",
        "lng": "30.38341391520970",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "2070",
        "town": "Erenler",
        "location": "Erenler/Sakarya",
        "lat": "40.73889203033320",
        "lng": "30.41411865229700",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1925",
        "town": "Ferizli",
        "location": "Ferizli/Sakarya",
        "lat": "40.92860613238590",
        "lng": "30.48987863391830",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1351",
        "town": "Geyve",
        "location": "Geyve/Sakarya",
        "lat": "40.52614604269320",
        "lng": "30.29620605939680",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1391",
        "town": "Hendek",
        "location": "Hendek/Sakarya",
        "lat": "40.79900853579030",
        "lng": "30.74146102766260",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1955",
        "town": "Karapürçek",
        "location": "Karapürçek/Sakarya",
        "lat": "40.64216556806330",
        "lng": "30.53755571370360",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1442",
        "town": "Karasu",
        "location": "Karasu/Sakarya",
        "lat": "41.10522337567480",
        "lng": "30.69258636148690",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1453",
        "town": "Kaynarca",
        "location": "Kaynarca/Sakarya",
        "lat": "41.02395592111000",
        "lng": "30.31123565490620",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1818",
        "town": "Kocaali",
        "location": "Kocaali/Sakarya",
        "lat": "41.07146428896530",
        "lng": "30.85628189448820",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1833",
        "town": "Pamukova",
        "location": "Pamukova/Sakarya",
        "lat": "40.50561065434210",
        "lng": "30.16928973187170",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1595",
        "town": "Sapanca",
        "location": "Sapanca/Sakarya",
        "lat": "40.68971703608200",
        "lng": "30.26141272572980",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "2071",
        "town": "Serdivan",
        "location": "Serdivan/Sakarya",
        "lat": "40.77215487340610",
        "lng": "30.36426569583710",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1986",
        "town": "Söğütlü",
        "location": "Söğütlü/Sakarya",
        "lat": "40.87858098202470",
        "lng": "30.46778735993070",
        "region": "Marmara"
    },
    {
        "cityId": "54",
        "city": "Sakarya",
        "townId": "1847",
        "town": "Taraklı",
        "location": "Taraklı/Sakarya",
        "lat": "40.39824548768270",
        "lng": "30.50689775125130",
        "region": "Marmara"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "2074",
        "town": "İlkadım",
        "location": "İlkadım/Samsun (Merkez)",
        "lat": "41.3024448301113",
        "lng": "36.3311543686128",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1830",
        "town": "19 Mayıs",
        "location": "19 Mayıs/Samsun",
        "lat": "41.49364777910020",
        "lng": "36.08106419619010",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1125",
        "town": "Alaçam",
        "location": "Alaçam/Samsun",
        "lat": "41.61646551255000",
        "lng": "35.60732749444481",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1763",
        "town": "Asarcık",
        "location": "Asarcık/Samsun",
        "lat": "41.03575015938950",
        "lng": "36.22714558011410",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "2072",
        "town": "Atakum",
        "location": "Atakum/Samsun",
        "lat": "41.33088222498900",
        "lng": "36.28929577241891",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1879",
        "town": "Ayvacık",
        "location": "Ayvacık/Samsun",
        "lat": "41.00723312721260",
        "lng": "36.63021863082030",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1164",
        "town": "Bafra",
        "location": "Bafra/Samsun",
        "lat": "41.55609403915291",
        "lng": "35.90455430358341",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "2073",
        "town": "Canik",
        "location": "Canik/Samsun",
        "lat": "41.27237857887850",
        "lng": "36.36597026324080",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1234",
        "town": "Çarşamba",
        "location": "Çarşamba/Samsun",
        "lat": "41.20395901955360",
        "lng": "36.72221729358970",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1386",
        "town": "Havza",
        "location": "Havza/Samsun",
        "lat": "40.96158355746310",
        "lng": "35.66618285727040",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1452",
        "town": "Kavak",
        "location": "Kavak/Samsun",
        "lat": "41.06992147454970",
        "lng": "36.02894862752700",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1501",
        "town": "Ladik",
        "location": "Ladik/Samsun",
        "lat": "40.91696130012060",
        "lng": "35.89552437679410",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1838",
        "town": "Salıpazarı",
        "location": "Salıpazarı/Samsun",
        "lat": "41.08458462529000",
        "lng": "36.82194319817770",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1849",
        "town": "Tekkeköy",
        "location": "Tekkeköy/Samsun",
        "lat": "41.22425032459110",
        "lng": "36.45178359534400",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1676",
        "town": "Terme",
        "location": "Terme/Samsun",
        "lat": "41.21243900242620",
        "lng": "36.97345532073440",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1712",
        "town": "Vezirköprü",
        "location": "Vezirköprü/Samsun",
        "lat": "41.14032798308560",
        "lng": "35.47075585431620",
        "region": "Karadeniz"
    },
    {
        "cityId": "55",
        "city": "Samsun",
        "townId": "1993",
        "town": "Yakakent",
        "location": "Yakakent/Samsun",
        "lat": "41.63139474114260",
        "lng": "35.53038731596360",
        "region": "Karadeniz"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1620",
        "town": "Merkez",
        "location": "Merkez/Siirt",
        "lat": "37,9176150215661",
        "lng": "41,9185868536269",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1179",
        "town": "Baykan",
        "location": "Baykan/Siirt",
        "lat": "38.15958559012180",
        "lng": "41.77997317904410",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1317",
        "town": "Eruh",
        "location": "Eruh/Siirt",
        "lat": "37.75330209925530",
        "lng": "42.17955318773820",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1495",
        "town": "Kurtalan",
        "location": "Kurtalan/Siirt",
        "lat": "37.93962478415780",
        "lng": "41.70790978819150",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1575",
        "town": "Pervari",
        "location": "Pervari/Siirt",
        "lat": "37.93468107603970",
        "lng": "42.54201918179650",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1662",
        "town": "Şirvan",
        "location": "Şirvan/Siirt",
        "lat": "38.05571723549170",
        "lng": "42.03567293139480",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "56",
        "city": "Siirt",
        "townId": "1878",
        "town": "Tillo",
        "location": "Tillo/Siirt",
        "lat": "37.95394056681950",
        "lng": "42.00643765934610",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1627",
        "town": "Merkez",
        "location": "Merkez/Sinop",
        "lat": "42,007388058233",
        "lng": "35,0975317062092",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1156",
        "town": "Ayancık",
        "location": "Ayancık/Sinop",
        "lat": "41.93772244608261",
        "lng": "34.58914851273680",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1204",
        "town": "Boyabat",
        "location": "Boyabat/Sinop",
        "lat": "41.46208504508810",
        "lng": "34.78676035353150",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1910",
        "town": "Dikmen",
        "location": "Dikmen/Sinop",
        "lat": "41.65050350434000",
        "lng": "35.26761283075610",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1290",
        "town": "Durağan",
        "location": "Durağan/Sinop",
        "lat": "41.41738319897771",
        "lng": "35.05154429268900",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1314",
        "town": "Erfelek",
        "location": "Erfelek/Sinop",
        "lat": "41.88102962789060",
        "lng": "34.90426321568360",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1349",
        "town": "Gerze",
        "location": "Gerze/Sinop",
        "lat": "41.80449376421020",
        "lng": "35.19077033398181",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1981",
        "town": "Saraydüzü",
        "location": "Saraydüzü/Sinop",
        "lat": "41.33158178186440",
        "lng": "34.84474687796321",
        "region": "Karadeniz"
    },
    {
        "cityId": "57",
        "city": "Sinop",
        "townId": "1693",
        "town": "Türkeli",
        "location": "Türkeli/Sinop",
        "lat": "41.94824187291691",
        "lng": "34.33953777134210",
        "region": "Karadeniz"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1628",
        "town": "Merkez",
        "location": "Merkez/Sivas",
        "lat": "39,7324566439146",
        "lng": "37,0148148228371",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1870",
        "town": "Akıncılar",
        "location": "Akıncılar/Sivas",
        "lat": "40.09079207113700",
        "lng": "38.34509280603340",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1875",
        "town": "Altınyayla",
        "location": "Altınyayla/Sivas",
        "lat": "39.27442724020400",
        "lng": "36.74887782269230",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1282",
        "town": "Divriği",
        "location": "Divriği/Sivas",
        "lat": "39.37938887449100",
        "lng": "38.11592351371520",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1913",
        "town": "Doğanşar",
        "location": "Doğanşar/Sivas",
        "lat": "40.21082224578361",
        "lng": "37.54185195785481",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1342",
        "town": "Gemerek",
        "location": "Gemerek/Sivas",
        "lat": "39.18583550674991",
        "lng": "36.08403500208010",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1927",
        "town": "Gölova",
        "location": "Gölova/Sivas",
        "lat": "40.06119035782671",
        "lng": "38.60273635428880",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1373",
        "town": "Gürün",
        "location": "Gürün/Sivas",
        "lat": "38.72189714627550",
        "lng": "37.27872392628921",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1376",
        "town": "Hafik",
        "location": "Hafik/Sivas",
        "lat": "39.85164901762700",
        "lng": "37.38723212120170",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1407",
        "town": "İmranlı",
        "location": "İmranlı/Sivas",
        "lat": "39.87157973946490",
        "lng": "38.11112067432750",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1431",
        "town": "Kangal",
        "location": "Kangal/Sivas",
        "lat": "39.22905407656470",
        "lng": "37.38855255597330",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1484",
        "town": "Koyulhisar",
        "location": "Koyulhisar/Sivas",
        "lat": "40.29607718061240",
        "lng": "37.83209298284590",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1646",
        "town": "Suşehri",
        "location": "Suşehri/Sivas",
        "lat": "40.16885907042420",
        "lng": "38.09870163973650",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1650",
        "town": "Şarkışla",
        "location": "Şarkışla/Sivas",
        "lat": "39.35744941537120",
        "lng": "36.40654300407410",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1991",
        "town": "Ulaş",
        "location": "Ulaş/Sivas",
        "lat": "39.44273831423430",
        "lng": "37.03515471988650",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1731",
        "town": "Yıldızeli",
        "location": "Yıldızeli/Sivas",
        "lat": "39.87168373346580",
        "lng": "36.59891366778141",
        "region": "İç Anadolu"
    },
    {
        "cityId": "58",
        "city": "Sivas",
        "townId": "1738",
        "town": "Zara",
        "location": "Zara/Sivas",
        "lat": "39.89505994392320",
        "lng": "37.75162064096930",
        "region": "İç Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "2091",
        "town": "Eyyübiye",
        "location": "Eyyübiye/Şanlıurfa (Merkez)",
        "lat": "37.1674721152114",
        "lng": "38.7956700272575",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1115",
        "town": "Akçakale",
        "location": "Akçakale/Şanlıurfa",
        "lat": "36.72446771625580",
        "lng": "38.94800955808320",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1194",
        "town": "Birecik",
        "location": "Birecik/Şanlıurfa",
        "lat": "37.02355475417650",
        "lng": "37.98725514280190",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1209",
        "town": "Bozova",
        "location": "Bozova/Şanlıurfa",
        "lat": "37.35636134693650",
        "lng": "38.52350647579361",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1220",
        "town": "Ceylanpınar",
        "location": "Ceylanpınar/Şanlıurfa",
        "lat": "36.87299754478840",
        "lng": "40.04077983571660",
        "region": "Güneydoğu Anadolu"
    },
    
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1378",
        "town": "Halfeti",
        "location": "Halfeti/Şanlıurfa",
        "lat": "37.24441423037190",
        "lng": "37.87291363299470",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "2092",
        "town": "Haliliye",
        "location": "Haliliye/Şanlıurfa",
        "lat": "37.16747211521141",
        "lng": "38.79567002725750",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1800",
        "town": "Harran",
        "location": "Harran/Şanlıurfa",
        "lat": "36.86185490945080",
        "lng": "39.01469115830740",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1393",
        "town": "Hilvan",
        "location": "Hilvan/Şanlıurfa",
        "lat": "37.57978980394370",
        "lng": "38.94890896989130",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "2093",
        "town": "Karaköprü",
        "location": "Karaköprü/Şanlıurfa",
        "lat": "37.18759103999370",
        "lng": "38.79748287703201",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1630",
        "town": "Siverek",
        "location": "Siverek/Şanlıurfa",
        "lat": "37.74182931941170",
        "lng": "39.30771223040530",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1643",
        "town": "Suruç",
        "location": "Suruç/Şanlıurfa",
        "lat": "36.98641723865100",
        "lng": "38.42730681575550",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "63",
        "city": "Şanlıurfa",
        "townId": "1713",
        "town": "Viranşehir",
        "location": "Viranşehir/Şanlıurfa",
        "lat": "37.22833794475780",
        "lng": "39.77143329068950",
        "region": "Güneydoğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1661",
        "town": "Merkez",
        "location": "Merkez/Şırnak",
        "lat": "37,5140175421209",
        "lng": "42,4404768000065",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1189",
        "town": "Beytüşşebap",
        "location": "Beytüşşebap/Şırnak",
        "lat": "37.56948645695391",
        "lng": "43.15826596435840",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1223",
        "town": "Cizre",
        "location": "Cizre/Şırnak",
        "lat": "37.33246700273910",
        "lng": "42.18545752666440",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1931",
        "town": "Güçlükonak",
        "location": "Güçlükonak/Şırnak",
        "lat": "37.47565125194100",
        "lng": "41.90820541312330",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1403",
        "town": "İdil",
        "location": "İdil/Şırnak",
        "lat": "37.34564247029560",
        "lng": "41.91447993588230",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1623",
        "town": "Silopi",
        "location": "Silopi/Şırnak",
        "lat": "37.24821671808880",
        "lng": "42.43518857703260",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "73",
        "city": "Şırnak",
        "townId": "1698",
        "town": "Uludere",
        "location": "Uludere/Şırnak",
        "lat": "37.45105972943150",
        "lng": "42.83017249013271",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "2096",
        "town": "Süleymanpaşa",
        "location": "Süleymanpaşa/Tekirdağ (Merkez)",
        "lat": "40.9961830566739",
        "lng": "27.5109924341978",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1250",
        "town": "Çerkezköy",
        "location": "Çerkezköy/Tekirdağ",
        "lat": "41.28374983367920",
        "lng": "28.01444626725760",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1258",
        "town": "Çorlu",
        "location": "Çorlu/Tekirdağ",
        "lat": "41.15001221235480",
        "lng": "27.77669472756620",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "2094",
        "town": "Ergene",
        "location": "Ergene/Tekirdağ",
        "lat": "41.19985639261620",
        "lng": "27.75862588895090",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1388",
        "town": "Hayrabolu",
        "location": "Hayrabolu/Tekirdağ",
        "lat": "41.20905675627791",
        "lng": "27.11598689251420",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "2095",
        "town": "Kapaklı",
        "location": "Kapaklı/Tekirdağ",
        "lat": "41.32445393020720",
        "lng": "27.97705285908750",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1511",
        "town": "Malkara",
        "location": "Malkara/Tekirdağ",
        "lat": "40.88552676070620",
        "lng": "26.91394744311400",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1825",
        "town": "Marmaraereğlisi",
        "location": "Marmaraereğlisi/Tekirdağ",
        "lat": "40.97414452831110",
        "lng": "27.94844493028220",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1538",
        "town": "Muratlı",
        "location": "Muratlı/Tekirdağ",
        "lat": "41.15830618033800",
        "lng": "27.49189992535480",
        "region": "Marmara"
    },
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1596",
        "town": "Saray",
        "location": "Saray/Tekirdağ",
        "lat": "41.43129292820020",
        "lng": "27.90949073668550",
        "region": "Marmara"
    },
    
    {
        "cityId": "59",
        "city": "Tekirdağ",
        "townId": "1652",
        "town": "Şarköy",
        "location": "Şarköy/Tekirdağ",
        "lat": "40.61745877614880",
        "lng": "27.09965125421760",
        "region": "Marmara"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1679",
        "town": "Merkez",
        "location": "Merkez/Tokat",
        "lat": "40,3295841459857",
        "lng": "36,5554902819699",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1129",
        "town": "Almus",
        "location": "Almus/Tokat",
        "lat": "40.37720711480850",
        "lng": "36.89473446717990",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1151",
        "town": "Artova",
        "location": "Artova/Tokat",
        "lat": "40.11480347585520",
        "lng": "36.30746275232670",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1883",
        "town": "Başçiftlik",
        "location": "Başçiftlik/Tokat",
        "lat": "40.54061544690200",
        "lng": "37.16709435703880",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1308",
        "town": "Erbaa",
        "location": "Erbaa/Tokat",
        "lat": "40.68362448631090",
        "lng": "36.57155275668750",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1545",
        "town": "Niksar",
        "location": "Niksar/Tokat",
        "lat": "40.58081188750851",
        "lng": "36.92655966533660",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1834",
        "town": "Pazar",
        "location": "Pazar/Tokat",
        "lat": "40.28194802428260",
        "lng": "36.29122249062120",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1584",
        "town": "Reşadiye",
        "location": "Reşadiye/Tokat",
        "lat": "40.38588942088140",
        "lng": "37.33504336181890",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1987",
        "town": "Sulusaray",
        "location": "Sulusaray/Tokat",
        "lat": "39.99584574296000",
        "lng": "36.09178712956630",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1690",
        "town": "Turhal",
        "location": "Turhal/Tokat",
        "lat": "40.37505092534510",
        "lng": "36.09680496255910",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1858",
        "town": "Yeşilyurt",
        "location": "Yeşilyurt/Tokat",
        "lat": "40.00683784418490",
        "lng": "36.21476891749640",
        "region": "Karadeniz"
    },
    {
        "cityId": "60",
        "city": "Tokat",
        "townId": "1740",
        "town": "Zile",
        "location": "Zile/Tokat",
        "lat": "40.29414390898930",
        "lng": "35.89084434320260",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "2097",
        "town": "Ortahisar",
        "location": "Ortahisar/Trabzon (Merkez)",
        "lat": "41.0087811197944",
        "lng": "39.7170897825417",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1113",
        "town": "Akçaabat",
        "location": "Akçaabat/Trabzon",
        "lat": "41.02136977275960",
        "lng": "39.57596253983120",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1141",
        "town": "Araklı",
        "location": "Araklı/Trabzon",
        "lat": "40.94347669942090",
        "lng": "40.05159842408200",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1150",
        "town": "Arsin",
        "location": "Arsin/Trabzon",
        "lat": "40.95434449973160",
        "lng": "39.92424661438281",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1775",
        "town": "Beşikdüzü",
        "location": "Beşikdüzü/Trabzon",
        "lat": "41.05461884251290",
        "lng": "39.22780914236050",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1896",
        "town": "Çarşıbaşı",
        "location": "Çarşıbaşı/Trabzon",
        "lat": "41.08924757111670",
        "lng": "39.38770499482041",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1244",
        "town": "Çaykara",
        "location": "Çaykara/Trabzon",
        "lat": "40.75822020051150",
        "lng": "40.24983095779690",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1909",
        "town": "Dernekpazarı",
        "location": "Dernekpazarı/Trabzon",
        "lat": "40.80488122669710",
        "lng": "40.25405989728630",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1917",
        "town": "Düzköy",
        "location": "Düzköy/Trabzon",
        "lat": "40.87444117214830",
        "lng": "39.42564554214490",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1942",
        "town": "Hayrat",
        "location": "Hayrat/Trabzon",
        "lat": "40.89108445189870",
        "lng": "40.36653798643600",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1966",
        "town": "Köprübaşı",
        "location": "Köprübaşı/Trabzon",
        "lat": "40.81089460606300",
        "lng": "40.12168690325880",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1507",
        "town": "Maçka",
        "location": "Maçka/Trabzon",
        "lat": "40.81665159112010",
        "lng": "39.61083912911900",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1548",
        "town": "Of",
        "location": "Of/Trabzon",
        "lat": "40.94259479012810",
        "lng": "40.26695935291920",
        "region": "Karadeniz"
    },
    
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1647",
        "town": "Sürmene",
        "location": "Sürmene/Trabzon",
        "lat": "40.91535596112560",
        "lng": "40.10823367285830",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1842",
        "town": "Şalpazarı",
        "location": "Şalpazarı/Trabzon",
        "lat": "40.94747974837010",
        "lng": "39.19571437190080",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1681",
        "town": "Tonya",
        "location": "Tonya/Trabzon",
        "lat": "40.89571931875940",
        "lng": "39.29494411666451",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1709",
        "town": "Vakfıkebir",
        "location": "Vakfıkebir/Trabzon",
        "lat": "41.04986623058160",
        "lng": "39.28022465446510",
        "region": "Karadeniz"
    },
    {
        "cityId": "61",
        "city": "Trabzon",
        "townId": "1732",
        "town": "Yomra",
        "location": "Yomra/Trabzon",
        "lat": "40.95876572367700",
        "lng": "39.85093238405800",
        "region": "Karadeniz"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1688",
        "town": "Merkez",
        "location": "Merkez/Tunceli",
        "lat": "39,1031324326587",
        "lng": "39,5530002375032",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1247",
        "town": "Çemişgezek",
        "location": "Çemişgezek/Tunceli",
        "lat": "39.05203192307000",
        "lng": "38.91642600846710",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1397",
        "town": "Hozat",
        "location": "Hozat/Tunceli",
        "lat": "39.09999492213480",
        "lng": "39.23154000551200",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1518",
        "town": "Mazgirt",
        "location": "Mazgirt/Tunceli",
        "lat": "39.01538367504310",
        "lng": "39.60065796152820",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1541",
        "town": "Nazımiye",
        "location": "Nazımiye/Tunceli",
        "lat": "39.18135695561751",
        "lng": "39.82503578047100",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1562",
        "town": "Ovacık",
        "location": "Ovacık/Tunceli",
        "lat": "39.35621936373181",
        "lng": "39.24097559830250",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1574",
        "town": "Pertek",
        "location": "Pertek/Tunceli",
        "lat": "38.85699168183420",
        "lng": "39.33534908286280",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "62",
        "city": "Tunceli",
        "townId": "1581",
        "town": "Pülümür",
        "location": "Pülümür/Tunceli",
        "lat": "39.48336906000410",
        "lng": "39.89779893614100",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1704",
        "town": "Merkez",
        "location": "Merkez/Uşak",
        "lat": "38,6710971766164",
        "lng": "29,4006191328784",
        "region": "Ege"
    },
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1170",
        "town": "Banaz",
        "location": "Banaz/Uşak",
        "lat": "38.73996298934180",
        "lng": "29.75318786160950",
        "region": "Ege"
    },
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1323",
        "town": "Eşme",
        "location": "Eşme/Uşak",
        "lat": "38.41072947325600",
        "lng": "28.97783034376040",
        "region": "Ege"
    },
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1436",
        "town": "Karahallı",
        "location": "Karahallı/Uşak",
        "lat": "38.32690924933870",
        "lng": "29.54519191165450",
        "region": "Ege"
    },
    
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1629",
        "town": "Sivaslı",
        "location": "Sivaslı/Uşak",
        "lat": "38.49841589856441",
        "lng": "29.67935520237460",
        "region": "Ege"
    },
    {
        "cityId": "64",
        "city": "Uşak",
        "townId": "1697",
        "town": "Ulubey",
        "location": "Ulubey/Uşak",
        "lat": "38.42977724108681",
        "lng": "29.29550242026110",
        "region": "Ege"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "2098",
        "town": "İpekyolu",
        "location": "İpekyolu/Van (Merkez)",
        "lat": "38.5011941961535",
        "lng": "43.3729448795259",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1770",
        "town": "Bahçesaray",
        "location": "Bahçesaray/Van",
        "lat": "38.12894026103530",
        "lng": "42.80607804951630",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1175",
        "town": "Başkale",
        "location": "Başkale/Van",
        "lat": "38.04458559572730",
        "lng": "44.01926462071600",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1786",
        "town": "Çaldıran",
        "location": "Çaldıran/Van",
        "lat": "39.12633505008490",
        "lng": "43.88916434556240",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1236",
        "town": "Çatak",
        "location": "Çatak/Van",
        "lat": "38.02815671921960",
        "lng": "43.04993344414030",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1918",
        "town": "Edremit",
        "location": "Edremit/Van",
        "lat": "38.42560683576910",
        "lng": "43.25018335412950",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1309",
        "town": "Erciş",
        "location": "Erciş/Van",
        "lat": "39.01830544734550",
        "lng": "43.38546990183600",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1350",
        "town": "Gevaş",
        "location": "Gevaş/Van",
        "lat": "38.30792212053590",
        "lng": "43.12234300757680",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1372",
        "town": "Gürpınar",
        "location": "Gürpınar/Van",
        "lat": "38.32614285325161",
        "lng": "43.40810788368790",
        "region": "Doğu Anadolu"
    },
    
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1533",
        "town": "Muradiye",
        "location": "Muradiye/Van",
        "lat": "39.00432681772770",
        "lng": "43.75056748322320",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1565",
        "town": "Özalp",
        "location": "Özalp/Van",
        "lat": "38.65662613920170",
        "lng": "43.97995413420780",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "1980",
        "town": "Saray",
        "location": "Saray/Van",
        "lat": "38.64958655304580",
        "lng": "44.16459300746750",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "65",
        "city": "Van",
        "townId": "2099",
        "town": "Tuşba",
        "location": "Tuşba/Van",
        "lat": "38.50119419615350",
        "lng": "43.37294487952591",
        "region": "Doğu Anadolu"
    },
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "1716",
        "town": "Merkez",
        "location": "Merkez/Yalova",
        "lat": "40,6566528018857",
        "lng": "29,283818004001",
        "region": "Marmara"
    },
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "2019",
        "town": "Altınova",
        "location": "Altınova/Yalova",
        "lat": "40.69659522126480",
        "lng": "29.51021826650630",
        "region": "Marmara"
    },
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "2020",
        "town": "Armutlu",
        "location": "Armutlu/Yalova",
        "lat": "40.51604050962880",
        "lng": "28.83121294533970",
        "region": "Marmara"
    },
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "2021",
        "town": "Çınarcık",
        "location": "Çınarcık/Yalova",
        "lat": "40.65066123800510",
        "lng": "29.15392448571500",
        "region": "Marmara"
    },
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "2022",
        "town": "Çiftlikköy",
        "location": "Çiftlikköy/Yalova",
        "lat": "40.66450022826330",
        "lng": "29.32288320761200",
        "region": "Marmara"
    },
    
    {
        "cityId": "77",
        "city": "Yalova",
        "townId": "2026",
        "town": "Termal",
        "location": "Termal/Yalova",
        "lat": "40.60603724154120",
        "lng": "29.18420598889210",
        "region": "Marmara"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1733",
        "town": "Merkez",
        "location": "Merkez/Yozgat",
        "lat": "39,8209480148444",
        "lng": "34,8086319312847",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1117",
        "town": "Akdağmadeni",
        "location": "Akdağmadeni/Yozgat",
        "lat": "39.67140312799301",
        "lng": "35.86966060787240",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1877",
        "town": "Aydıncık",
        "location": "Aydıncık/Yozgat",
        "lat": "40.13298988703000",
        "lng": "35.28306036713160",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1198",
        "town": "Boğazlıyan",
        "location": "Boğazlıyan/Yozgat",
        "lat": "39.18659779282980",
        "lng": "35.23963402951910",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1895",
        "town": "Çandır",
        "location": "Çandır/Yozgat",
        "lat": "39.23041064901510",
        "lng": "35.49413966227450",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1242",
        "town": "Çayıralan",
        "location": "Çayıralan/Yozgat",
        "lat": "39.30221592336620",
        "lng": "35.62092144309820",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1245",
        "town": "Çekerek",
        "location": "Çekerek/Yozgat",
        "lat": "40.05701023831310",
        "lng": "35.50189640388850",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1952",
        "town": "Kadışehri",
        "location": "Kadışehri/Yozgat",
        "lat": "39.99026013137480",
        "lng": "35.78814459345990",
        "region": "İç Anadolu"
    },
    
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1982",
        "town": "Saraykent",
        "location": "Saraykent/Yozgat",
        "lat": "39.67251370373090",
        "lng": "35.51588495734010",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1602",
        "town": "Sarıkaya",
        "location": "Sarıkaya/Yozgat",
        "lat": "39.49360039618290",
        "lng": "35.37548445704671",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1635",
        "town": "Sorgun",
        "location": "Sorgun/Yozgat",
        "lat": "39.81359561150360",
        "lng": "35.18585009023600",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1655",
        "town": "Şefaatli",
        "location": "Şefaatli/Yozgat",
        "lat": "39.51164331129360",
        "lng": "34.75689544752101",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1998",
        "town": "Yenifakılı",
        "location": "Yenifakılı/Yozgat",
        "lat": "39.22422042960951",
        "lng": "34.99295815646100",
        "region": "İç Anadolu"
    },
    {
        "cityId": "66",
        "city": "Yozgat",
        "townId": "1726",
        "town": "Yerköy",
        "location": "Yerköy/Yozgat",
        "lat": "39.66404015770470",
        "lng": "34.50093974869060",
        "region": "İç Anadolu"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1741",
        "town": "Merkez",
        "location": "Merkez/Zonguldak",
        "lat": "41,4526444074017",
        "lng": "31,7876418641283",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1758",
        "town": "Alaplı",
        "location": "Alaplı/Zonguldak",
        "lat": "41.18445418103230",
        "lng": "31.38542717897760",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1240",
        "town": "Çaycuma",
        "location": "Çaycuma/Zonguldak",
        "lat": "41.42606304844110",
        "lng": "32.09104251400460",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1276",
        "town": "Devrek",
        "location": "Devrek/Zonguldak",
        "lat": "41.22655703618550",
        "lng": "31.96415510379230",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1313",
        "town": "Ereğli",
        "location": "Ereğli/Zonguldak",
        "lat": "41.26962254384750",
        "lng": "31.43496777455140",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "1926",
        "town": "Gökçebey",
        "location": "Gökçebey/Zonguldak",
        "lat": "41.29994317746550",
        "lng": "32.11978762907170",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "2100",
        "town": "Kilimli",
        "location": "Kilimli/Zonguldak",
        "lat": "41.49163025739920",
        "lng": "31.83946262270120",
        "region": "Karadeniz"
    },
    {
        "cityId": "67",
        "city": "Zonguldak",
        "townId": "2101",
        "town": "Kozlu",
        "location": "Kozlu/Zonguldak",
        "lat": "41.43672324285980",
        "lng": "31.74201319014470",
        "region": "Karadeniz"
    },
    
]


export default addLoadLocationData